// faCategories.js
import React from "react";

import {
  FaBeer,
  FaCoffee,
  FaAppleAlt,
  FaCarrot,
  FaAmbulance,
  FaAnchor,
  FaArchway,
  FaAtlas,
  FaAtom,
  FaAward,
  FaBaby,
  FaBacon,
  FaBahai,
  FaBalanceScale,
  FaBan,
  FaBandAid,
  FaBarcode,
  FaBars,
  FaBaseballBall,
  FaBasketballBall,
  FaBath,
  FaBatteryFull,
  FaBed,
  FaBell,
  FaBicycle,
  FaBinoculars,
  FaBiohazard,
  FaBirthdayCake,
  FaBlender,
  FaBolt,
  FaBomb,
  FaBone,
  FaBook,
  FaBookmark,
  FaBowlingBall,
  FaBox,
  FaBrain,
  FaBreadSlice,
  FaBriefcase,
  FaBroadcastTower,
  FaBroom,
  FaBrush,
  FaBug,
  FaBuilding,
  FaBullhorn,
  FaBullseye,
  FaBurn,
  FaBus,
  FaCalculator,
  FaCalendar,
  FaCamera,
  FaCandyCane,
  FaCapsules,
  FaCar,
  FaCat,
  FaCertificate,
  FaChair,
  FaChalkboard,
  FaChartBar,
  FaChartLine,
  FaChartPie,
  FaChess,
  FaChild,
  FaChurch,
  FaCircle,
  FaClipboard,
  FaClock,
  FaClone,
  FaClosedCaptioning,
  FaCloud,
  FaCocktail,
  FaCode,
  FaCog,
  FaCogs,
  FaCoins,
  FaColumns,
  FaComment,
  FaCompass,
  FaCompress,
  FaConciergeBell,
  FaCookie,
  FaCopy,
  FaCopyright,
  FaCouch,
  FaCreditCard,
  FaCrop,
  FaCross,
  FaCrosshairs,
  FaCrow,
  FaCrown,
  FaCube,
  FaCut,
  FaDatabase,
  FaDeaf,
  FaDemocrat,
  FaDesktop,
  FaDharmachakra,
  FaDiagnoses,
  FaDice,
  FaDigitalTachograph,
  FaDirections,
  FaDisease,
  FaDivide,
  FaDna,
  FaDog,
  FaDollarSign,
  FaDolly,
  FaDoorClosed,
  FaDove,
  FaDownload,
  FaDraftingCompass,
  FaDragon,
  FaDrum,
  FaDrumstickBite,
  FaDumbbell,
  FaDumpsterFire,
  FaDungeon,
  FaEdit,
  FaEgg,
  FaEject,
  FaEllipsisH,
  FaEllipsisV,
  FaEnvelope,
  FaEraser,
  FaEthernet,
  FaEuroSign,
  FaExchangeAlt,
  FaExclamation,
  FaExclamationCircle,
  FaExclamationTriangle,
  FaExpand,
  FaExpandArrowsAlt,
  FaExternalLinkAlt,
  FaEye,
  FaEyeDropper,
  FaFan,
  FaFastBackward,
  FaFastForward,
  FaFaucet,
  FaFax,
  FaFeather,
  FaFeatherAlt,
  FaFemale,
  FaFighterJet,
  FaFile,
  FaFileAlt,
  FaFilm,
  FaFilter,
  FaFingerprint,
  FaFire,
  FaFireAlt,
  FaFireExtinguisher,
  FaFirstAid,
  FaFish,
  FaFlag,
  FaFlask,
  FaFlushed,
  FaFolder,
  FaFont,
  FaFootballBall,
  FaForward,
  FaFrog,
  FaFrown,
  FaFrownOpen,
  FaFunnelDollar,
  FaFutbol,
  FaGamepad,
  FaGasPump,
  FaGavel,
  FaGem,
  FaGenderless,
  FaGhost,
  FaGift,
  FaGlassCheers,
  FaGlasses,
  FaGlobe,
  FaGolfBall,
  FaGopuram,
  FaGraduationCap,
  FaGreaterThan,
  FaGreaterThanEqual,
  FaGrin,
  FaGrinAlt,
  FaGrinBeam,
  FaGrinHearts,
  FaGrinSquint,
  FaGrinStars,
  FaGrinTears,
  FaGrinTongue,
  FaGrinTongueWink,
  FaGrinWink,
  FaGripHorizontal,
  FaGripVertical,
  FaGuitar,
  FaHSquare,
  FaHamburger,
  FaHammer,
  FaHandHolding,
  FaHandHoldingHeart,
  FaHandHoldingUsd,
  FaHandLizard,
  FaHandMiddleFinger,
  FaHandPaper,
  FaHandPeace,
  FaHandPointDown,
  FaHandPointLeft,
  FaHandPointRight,
  FaHandPointUp,
  FaHandRock,
  FaHandScissors,
  FaHandSparkles,
  FaHandSpock,
  FaHands,
  FaHandsHelping,
  FaHandshake,
  FaHardHat,
  FaHashtag,
  FaHatCowboy,
  FaHatCowboySide,
  FaHatWizard,
  FaHdd,
  FaHeading,
  FaHeadphones,
  FaHeadphonesAlt,
  FaHeadset,
  FaHeart,
  FaHeartBroken,
  FaHeartbeat,
  FaHelicopter,
  FaHighlighter,
  FaHiking,
  FaHippo,
  FaHistory,
  FaHockeyPuck,
  FaHollyBerry,
  FaHome,
  FaHorse,
  FaHorseHead,
  FaHospital,
  FaHotTub,
  FaHotdog,
  FaHotel,
  FaHourglass,
  FaHouseDamage,
  FaHryvnia,
  FaICursor,
  FaIceCream,
  FaIcons,
  // FaIdBadge / FaIdCard removed (bug #969, Gordon): their SVG glyph draws a
  // bordered card/badge frame around a tiny person silhouette, i.e. the "box"
  // is baked into the icon asset itself, not a wrapper style. No segment icon
  // may render inside a box, so these two are dropped from the picker.
  FaIgloo,
  FaImage,
  FaImages,
  FaInbox,
  FaIndent,
  FaIndustry,
  FaInfinity,
  FaInfo,
  FaInfoCircle,
  FaItalic,
  FaJedi,
  FaJoint,
  FaJournalWhills,
  FaKaaba,
  FaKey,
  FaKeyboard,
  FaKhanda,
  FaKiss,
  FaKissBeam,
  FaKissWinkHeart,
  FaKiwiBird,
  FaLandmark,
  FaLanguage,
  FaLaptop,
  FaLaptopCode,
  FaLaptopMedical,
  FaLaugh,
  FaLaughBeam,
  FaLaughSquint,
  FaLaughWink,
  FaLayerGroup,
  FaLeaf,
  FaLemon,
  FaLessThan,
  FaLessThanEqual,
  FaLevelDownAlt,
  FaLevelUpAlt,
  FaLifeRing,
  FaLightbulb,
  FaLink,
  FaLiraSign,
  FaList,
  FaListAlt,
  FaListOl,
  FaListUl,
  FaLocationArrow,
  FaLock,
  FaLockOpen,
  FaLongArrowAltDown,
  FaLongArrowAltLeft,
  FaLongArrowAltRight,
  FaLongArrowAltUp,
  FaLowVision,
  FaLuggageCart,
  FaMagic,
  FaMagnet,
  FaMailBulk,
  FaMale,
  FaMap,
  FaMapMarked,
  FaMapMarkedAlt,
  FaMapPin,
  FaMapSigns,
  FaMarker,
  FaMars,
  FaMarsDouble,
  FaMarsStroke,
  FaMarsStrokeH,
  FaMarsStrokeV,
  FaMask,
  FaMedal,
  FaMedkit,
  FaMeh,
  FaMehBlank,
  FaMehRollingEyes,
  FaMemory,
  FaMenorah,
  FaMercury,
  FaMeteor,
  FaMicrochip,
  FaMicrophone,
  FaMicrophoneAlt,
  FaMicrophoneAltSlash,
  FaMicrophoneSlash,
  FaMicroscope,
  FaMinus,
  FaMinusCircle,
  FaMinusSquare,
  FaMitten,
  FaMobile,
  FaMobileAlt,
  FaMoneyBill,
  FaMoneyBillAlt,
  FaMoneyBillWave,
  FaMoneyBillWaveAlt,
  FaMoneyCheck,
  FaMoneyCheckAlt,
  FaMonument,
  FaMoon,
  FaMortarPestle,
  FaMosque,
  FaMotorcycle,
  FaMountain,
  FaMouse,
  FaMousePointer,
  FaMugHot,
  FaMusic,
  FaNetworkWired,
  FaNeuter,
  FaNewspaper,
  FaNotEqual,
  FaNotesMedical,
  FaObjectGroup,
  FaObjectUngroup,
  FaOilCan,
  FaOm,
  FaOtter,
  FaOutdent,
  FaPager,
  FaPaintBrush,
  FaPaintRoller,
  FaPalette,
  FaPallet,
  FaPaperPlane,
  FaPaperclip,
  FaParachuteBox,
  FaParagraph,
  FaParking,
  FaPassport,
  FaPastafarianism,
  FaPaste,
  FaPause,
  FaPauseCircle,
  FaPaw,
  FaPeace,
  FaPen,
  FaPenAlt,
  FaPenFancy,
  FaPenNib,
  FaPenSquare,
  FaPencilAlt,
  FaPencilRuler,
  FaPeopleCarry,
  FaPepperHot,
  FaPercent,
  FaPercentage,
  FaPersonBooth,
  FaPhone,
  FaPhoneAlt,
  FaPhoneSlash,
  FaPhoneSquare,
  FaPhoneVolume,
  FaPhotoVideo,
  FaPiggyBank,
  FaPills,
  FaPizzaSlice,
  FaPlaceOfWorship,
  FaPlane,
  FaPlaneArrival,
  FaPlaneDeparture,
  FaPlay,
  FaPlayCircle,
  FaPlug,
  FaPlus,
  FaPlusCircle,
  FaPlusSquare,
  FaPodcast,
  FaPoll,
  FaPollH,
  FaPoo,
  FaPooStorm,
  FaPoop,
  FaPortrait,
  FaPoundSign,
  FaPowerOff,
  FaPray,
  FaPrayingHands,
  FaPrescription,
  FaPrescriptionBottle,
  FaPrint,
  FaProcedures,
  FaProjectDiagram,
  FaPumpMedical,
  FaPumpSoap,
  FaPuzzlePiece,
  FaQrcode,
  FaQuestion,
  FaQuestionCircle,
  FaQuidditch,
  FaQuoteLeft,
  FaQuoteRight,
  FaQuran,
  FaRadiation,
  FaRadiationAlt,
  FaRainbow,
  FaRandom,
  FaReceipt,
  FaRecordVinyl,
  FaRecycle,
  FaRedo,
  FaRegistered,
  FaRemoveFormat,
  FaReply,
  FaRepublican,
  FaRestroom,
  FaRetweet,
  FaRibbon,
  FaRing,
  FaRoad,
  FaRobot,
  FaRocket,
  FaRoute,
  FaRss,
  FaRssSquare,
  FaRubleSign,
  FaRuler,
  FaRunning,
  FaRupeeSign,
  FaSadCry,
  FaSadTear,
  FaSatellite,
  FaSatelliteDish,
  FaSave,
  FaSchool,
  FaScrewdriver,
  FaScroll,
  FaSdCard,
  FaSearch,
  FaSearchDollar,
  FaSearchLocation,
  FaSearchMinus,
  FaSearchPlus,
  FaSeedling,
  FaServer,
  FaShapes,
  FaShare,
  FaShareAlt,
  FaShareAltSquare,
  FaShareSquare,
  FaShekelSign,
  FaShieldAlt,
  FaShip,
  FaShippingFast,
  FaShoePrints,
  FaShoppingBag,
  FaShoppingBasket,
  FaShoppingCart,
  FaShower,
  FaShuttleVan,
  FaSign,
  FaSignInAlt,
  FaSignLanguage,
  FaSignOutAlt,
  FaSignal,
  FaSignature,
  FaSimCard,
  FaSink,
  FaSitemap,
  FaSkating,
  FaSkiing,
  FaSkiingNordic,
  FaSkull,
  FaSkullCrossbones,
  FaSlash,
  FaSleigh,
  FaSlidersH,
  FaSmile,
  FaSmileBeam,
  FaSmileWink,
  FaSmog,
  FaSmoking,
  FaSms,
  FaSnowboarding,
  FaSnowflake,
  FaSnowman,
  FaSnowplow,
  FaSoap,
  FaSocks,
  FaSolarPanel,
  FaSort,
  FaSortAlphaDown,
  FaSortAlphaDownAlt,
  FaSortAlphaUp,
  FaSortAlphaUpAlt,
  FaSortAmountDown,
  FaSortAmountDownAlt,
  FaSortAmountUp,
  FaSortAmountUpAlt,
  FaSortDown,
  FaSortNumericDown,
  FaSortNumericDownAlt,
  FaSortNumericUp,
  FaSortNumericUpAlt,
  FaSortUp,
  FaSpa,
  FaSpaceShuttle,
  FaSpellCheck,
  FaSpider,
  FaSpinner,
  FaSplotch,
  FaSprayCan,
  FaSquare,
  FaSquareFull,
  FaSquareRootAlt,
  FaStamp,
  FaStar,
  FaStarAndCrescent,
  FaStarHalf,
  FaStarOfDavid,
  FaStarOfLife,
  FaStepBackward,
  FaStepForward,
  FaStethoscope,
  FaStickyNote,
  FaStop,
  FaStopCircle,
  FaStopwatch,
  FaStopwatch20,
  FaStore,
  FaStoreAlt,
  FaStream,
  FaStreetView,
  FaStrikethrough,
  FaStroopwafel,
  FaSubscript,
  FaSubway,
  FaSuitcase,
  FaSuitcaseRolling,
  FaSun,
  FaSuperscript,
  FaSurprise,
  FaSwatchbook,
  FaSwimmer,
  FaSwimmingPool,
  FaSynagogue,
  FaSync,
  FaSyncAlt,
  FaSyringe,
  FaTable,
  FaTableTennis,
  FaTablet,
  FaTabletAlt,
  FaTablets,
  FaTachometerAlt,
  FaTag,
  FaTags,
  FaTape,
  FaTasks,
  FaTaxi,
  FaTeeth,
  FaTeethOpen,
  FaTemperatureHigh,
  FaTemperatureLow,
  FaTenge,
  FaTerminal,
  FaTextHeight,
  FaTextWidth,
  FaTh,
  FaThLarge,
  FaThList,
  FaTheaterMasks,
  FaThermometer,
  FaThumbsDown,
  FaThumbsUp,
  FaThumbtack,
  FaTicketAlt,
  FaTimes,
  FaTimesCircle,
  FaTint,
  FaTintSlash,
  FaTired,
  FaToggleOff,
  FaToggleOn,
  FaToilet,
  FaToiletPaper,
  FaToolbox,
  FaTools,
  FaTooth,
  FaTorah,
  FaToriiGate,
  FaTractor,
  FaTrademark,
  FaTrafficLight,
  FaTrain,
  FaTram,
  FaTrash,
  FaTrashAlt,
  FaTree,
  FaTrophy,
  FaTruck,
  FaTruckLoading,
  FaTruckMonster,
  FaTruckMoving,
  FaTruckPickup,
  FaTshirt,
  FaTty,
  FaTv,
  FaUmbrella,
  FaUmbrellaBeach,
  FaUnderline,
  FaUndo,
  FaUndoAlt,
  FaUniversalAccess,
  FaUniversity,
  FaUnlink,
  FaUnlock,
  FaUnlockAlt,
  FaUpload,
  FaUser,
  FaUserAlt,
  FaUserAltSlash,
  FaUserAstronaut,
  FaUserCheck,
  FaUserCircle,
  FaUserClock,
  FaUserCog,
  FaUserEdit,
  FaUserFriends,
  FaUserGraduate,
  FaUserInjured,
  FaUserLock,
  FaUserMd,
  FaUserMinus,
  FaUserNinja,
  FaUserNurse,
  FaUserPlus,
  FaUserSecret,
  FaUserShield,
  FaUserSlash,
  FaUserTag,
  FaUserTie,
  FaUserTimes,
  FaUsers,
  FaUtensilSpoon,
  FaUtensils,
  FaVectorSquare,
  FaVenus,
  FaVenusDouble,
  FaVenusMars,
  FaVest,
  FaVestPatches,
  FaVial,
  FaVials,
  FaVideo,
  FaVideoSlash,
  FaVihara,
  FaVirus,
  FaVirusSlash,
  FaVoicemail,
  FaVolleyballBall,
  FaVolumeDown,
  FaVolumeMute,
  FaVolumeOff,
  FaVolumeUp,
  FaVoteYea,
  FaVrCardboard,
  FaWalking,
  FaWallet,
  FaWarehouse,
  FaWater,
  FaWeight,
  FaWeightHanging,
  FaWheelchair,
  FaWifi,
  FaWind,
  FaWindowClose,
  FaWindowMaximize,
  FaWindowMinimize,
  FaWindowRestore,
  FaWineBottle,
  FaWineGlass,
  FaWineGlassAlt,
  FaWonSign,
  FaWrench,
  FaXRay,
  FaYenSign,
  FaYinYang,
} from "react-icons/fa";
import {
  FiAirplay,
  FiAlertCircle,
  FiAlignCenter,
  FiAlignJustify,
  FiAlignLeft,
  FiAlignRight,
  FiAnchor,
  FiAperture,
  FiArchive,
  FiArrowDownCircle,
  FiArrowDownLeft,
  FiArrowDownRight,
  FiArrowDown,
  FiArrowLeftCircle,
  FiArrowLeft,
  FiArrowRightCircle,
  FiArrowRight,
  FiArrowUpCircle,
  FiArrowUpLeft,
  FiArrowUpRight,
  FiArrowUp,
  FiAtSign,
  FiAward,
  FiBarChart,
  FiBarChart2,
  FiBattery,
  FiBatteryCharging,
  FiBell,
  FiBellOff,
  FiBluetooth,
  FiBold,
  FiBookOpen,
  FiBook,
  FiBookmark,
  FiBox,
  FiBriefcase,
  FiCalendar,
  FiCameraOff,
  FiCamera,
  FiCast,
  FiCheckCircle,
  FiCheckSquare,
  FiCheck,
  FiChevronDown,
  FiChevronLeft,
  FiChevronRight,
  FiChevronUp,
  FiChevronsDown,
  FiChevronsLeft,
  FiChevronsRight,
  FiChevronsUp,
  FiChrome,
  FiCircle,
  FiClipboard,
  FiClock,
  FiCloudDrizzle,
  FiCloudLightning,
  FiCloudOff,
  FiCloudRain,
  FiCloudSnow,
  FiCloud,
  FiCode,
  FiCodepen,
  FiCodesandbox,
  FiCoffee,
  FiColumns,
  FiCommand,
  FiCompass,
  FiCopy,
  FiCornerDownLeft,
  FiCornerDownRight,
  FiCornerLeftDown,
  FiCornerLeftUp,
  FiCornerRightDown,
  FiCornerRightUp,
  FiCornerUpLeft,
  FiCornerUpRight,
  FiCpu,
  FiCreditCard,
  FiCrop,
  FiCrosshair,
  FiDatabase,
  FiDelete,
  FiDisc,
  FiDivideCircle,
  FiDivideSquare,
  FiDivide,
  FiDollarSign,
  FiDownload,
  FiDroplet,
  FiEdit2,
  FiEdit3,
  FiEdit,
  FiExternalLink,
  FiEyeOff,
  FiEye,
  FiFacebook,
  FiFastForward,
  FiFeather,
  FiFigma,
  FiFileMinus,
  FiFilePlus,
  FiFileText,
  FiFile,
  FiFilm,
  FiFilter,
  FiFlag,
  FiFolderMinus,
  FiFolderPlus,
  FiFolder,
  FiFramer,
  FiFrown,
  FiGift,
  FiGitBranch,
  FiGitCommit,
  FiGitMerge,
  FiGitPullRequest,
  FiGithub,
  FiGitlab,
  FiGlobe,
  FiGrid,
  FiHardDrive,
  FiHash,
  FiHeadphones,
  FiHeart,
  FiHelpCircle,
  FiHexagon,
  FiHome,
  FiImage,
  FiInbox,
  FiInfo,
  FiInstagram,
  FiItalic,
  FiKey,
  FiLayers,
  FiLayout,
  FiLifeBuoy,
  FiLink2,
  FiLink,
  FiLinkedin,
  FiList,
  FiLoader,
  FiLock,
  FiLogIn,
  FiLogOut,
  FiMail,
  FiMapPin,
  FiMap,
  FiMaximize2,
  FiMaximize,
  FiMeh,
  FiMenu,
  FiMessageCircle,
  FiMessageSquare,
  FiMicOff,
  FiMic,
  FiMinimize2,
  FiMinimize,
  FiMinusCircle,
  FiMinusSquare,
  FiMinus,
  FiMonitor,
  FiMoon,
  FiMoreHorizontal,
  FiMoreVertical,
  FiMousePointer,
  FiMove,
  FiMusic,
  FiNavigation2,
  FiNavigation,
  FiOctagon,
  FiPackage,
  FiPaperclip,
  FiPauseCircle,
  FiPause,
  FiPenTool,
  FiPercent,
  FiPhoneCall,
  FiPhoneForwarded,
  FiPhoneIncoming,
  FiPhoneMissed,
  FiPhoneOff,
  FiPhoneOutgoing,
  FiPhone,
  FiPieChart,
  FiPlayCircle,
  FiPlay,
  FiPlusCircle,
  FiPlusSquare,
  FiPlus,
  FiPocket,
  FiPower,
  FiPrinter,
  FiRadio,
  FiRefreshCcw,
  FiRefreshCw,
  FiRepeat,
  FiRewind,
  FiRotateCcw,
  FiRotateCw,
  FiRss,
  FiSave,
  FiScissors,
  FiSearch,
  FiSend,
  FiServer,
  FiSettings,
  FiShare2,
  FiShare,
  FiShieldOff,
  FiShield,
  FiShoppingBag,
  FiShoppingCart,
  FiShuffle,
  FiSidebar,
  FiSkipBack,
  FiSkipForward,
  FiSlack,
  FiSlash,
  FiSliders,
  FiSmartphone,
  FiSmile,
  FiSpeaker,
  FiSquare,
  FiStar,
  FiStopCircle,
  FiSun,
  FiSunrise,
  FiSunset,
  FiTablet,
  FiTag,
  FiTarget,
  FiTerminal,
  FiThermometer,
  FiThumbsDown,
  FiThumbsUp,
  FiToggleLeft,
  FiToggleRight,
  FiTool,
  FiTrash2,
  FiTrash,
  FiTrello,
  FiTrendingDown,
  FiTrendingUp,
  FiTriangle,
  FiTruck,
  FiTv,
  FiTwitch,
  FiTwitter,
  FiType,
  FiUmbrella,
  FiUnderline,
  FiUnlock,
  FiUploadCloud,
  FiUpload,
  FiUserCheck,
  FiUserMinus,
  FiUserPlus,
  FiUserX,
  FiUser,
  FiUsers,
  FiVideoOff,
  FiVideo,
  FiVoicemail,
  FiVolume1,
  FiVolume2,
  FiVolumeX,
  FiVolume,
  FiWatch,
  FiWifiOff,
  FiWifi,
  FiWind,
  FiXCircle,
  FiXOctagon,
  FiXSquare,
  FiX,
  FiYoutube,
  FiZapOff,
  FiZap,
  FiZoomIn,
  FiZoomOut,
} from "react-icons/fi";
import {
  SiAdobe,
  SiAmazon,
  SiAndroid,
  SiAngular,
  SiApple,
  SiAzuredevops,
  SiBabel,
  SiBootstrap,
  SiCsharp,
  SiCss3,
  SiDjango,
  SiDocker,
  SiFacebook,
  SiFirefox,
  SiFlutter,
  SiFoursquare,
  SiGit,
  SiGithub,
  SiGitlab,
  SiGooglechrome,
  SiHeroku,
  SiHtml5,
  SiIntellijidea,
  SiJavascript,
  SiJenkins,
  SiJquery,
  SiKubernetes,
  SiLinkedin,
  SiLinux,
  SiMongodb,
  SiMysql,
  SiNativescript,
  SiNetlify,
  SiNpm,
  SiOracle,
  SiPhp,
  SiPostgresql,
  SiPython,
  SiReact,
  SiRedis,
  SiRedux,
  SiRuby,
  SiRust,
  SiSass,
  SiStackoverflow,
  SiTwitter,
  SiTypescript,
  SiVercel,
  SiVisualstudio,
  SiWebpack,
  SiWordpress,
  SiYarn,
} from "react-icons/si";

export const wrapIconWithDisplayName = (IconComponent, displayName) => {
  const WrappedIcon = (props) => <IconComponent {...props} />;
  WrappedIcon.displayName = displayName;
  return WrappedIcon;
};

const faCategories = {
  Regular: [
    wrapIconWithDisplayName(FiAirplay, "FiAirplay"),
    wrapIconWithDisplayName(FiAlertCircle, "FiAlertCircle"),
    wrapIconWithDisplayName(FiAlignCenter, "FiAlignCenter"),
    wrapIconWithDisplayName(FiAlignJustify, "FiAlignJustify"),
    wrapIconWithDisplayName(FiAlignLeft, "FiAlignLeft"),
    wrapIconWithDisplayName(FiAlignRight, "FiAlignRight"),
    wrapIconWithDisplayName(FiAnchor, "FiAnchor"),
    wrapIconWithDisplayName(FiAperture, "FiAperture"),
    wrapIconWithDisplayName(FiArchive, "FiArchive"),
    wrapIconWithDisplayName(FiArrowDownCircle, "FiArrowDownCircle"),
    wrapIconWithDisplayName(FiArrowDownLeft, "FiArrowDownLeft"),
    wrapIconWithDisplayName(FiArrowDownRight, "FiArrowDownRight"),
    wrapIconWithDisplayName(FiArrowDown, "FiArrowDown"),
    wrapIconWithDisplayName(FiArrowLeftCircle, "FiArrowLeftCircle"),
    wrapIconWithDisplayName(FiArrowLeft, "FiArrowLeft"),
    wrapIconWithDisplayName(FiArrowRightCircle, "FiArrowRightCircle"),
    wrapIconWithDisplayName(FiArrowRight, "FiArrowRight"),
    wrapIconWithDisplayName(FiArrowUpCircle, "FiArrowUpCircle"),
    wrapIconWithDisplayName(FiArrowUpLeft, "FiArrowUpLeft"),
    wrapIconWithDisplayName(FiArrowUpRight, "FiArrowUpRight"),
    wrapIconWithDisplayName(FiArrowUp, "FiArrowUp"),
    wrapIconWithDisplayName(FiAtSign, "FiAtSign"),
    wrapIconWithDisplayName(FiAward, "FiAward"),
    wrapIconWithDisplayName(FiBarChart, "FiBarChart"),
    wrapIconWithDisplayName(FiBarChart2, "FiBarChart2"),
    wrapIconWithDisplayName(FiBattery, "FiBattery"),
    wrapIconWithDisplayName(FiBatteryCharging, "FiBatteryCharging"),
    wrapIconWithDisplayName(FiBell, "FiBell"),
    wrapIconWithDisplayName(FiBellOff, "FiBellOff"),
    wrapIconWithDisplayName(FiBluetooth, "FiBluetooth"),
    wrapIconWithDisplayName(FiBold, "FiBold"),
    wrapIconWithDisplayName(FiBookOpen, "FiBookOpen"),
    wrapIconWithDisplayName(FiBook, "FiBook"),
    wrapIconWithDisplayName(FiBookmark, "FiBookmark"),
    wrapIconWithDisplayName(FiBox, "FiBox"),
    wrapIconWithDisplayName(FiBriefcase, "FiBriefcase"),
    wrapIconWithDisplayName(FiCalendar, "FiCalendar"),
    wrapIconWithDisplayName(FiCameraOff, "FiCameraOff"),
    wrapIconWithDisplayName(FiCamera, "FiCamera"),
    wrapIconWithDisplayName(FiCast, "FiCast"),
    wrapIconWithDisplayName(FiCheckCircle, "FiCheckCircle"),
    wrapIconWithDisplayName(FiCheckSquare, "FiCheckSquare"),
    wrapIconWithDisplayName(FiCheck, "FiCheck"),
    wrapIconWithDisplayName(FiChevronDown, "FiChevronDown"),
    wrapIconWithDisplayName(FiChevronLeft, "FiChevronLeft"),
    wrapIconWithDisplayName(FiChevronRight, "FiChevronRight"),
    wrapIconWithDisplayName(FiChevronUp, "FiChevronUp"),
    wrapIconWithDisplayName(FiChevronsDown, "FiChevronsDown"),
    wrapIconWithDisplayName(FiChevronsLeft, "FiChevronsLeft"),
    wrapIconWithDisplayName(FiChevronsRight, "FiChevronsRight"),
    wrapIconWithDisplayName(FiChevronsUp, "FiChevronsUp"),
    wrapIconWithDisplayName(FiChrome, "FiChrome"),
    wrapIconWithDisplayName(FiCircle, "FiCircle"),
    wrapIconWithDisplayName(FiClipboard, "FiClipboard"),
    wrapIconWithDisplayName(FiClock, "FiClock"),
    wrapIconWithDisplayName(FiCloudDrizzle, "FiCloudDrizzle"),
    wrapIconWithDisplayName(FiCloudLightning, "FiCloudLightning"),
    wrapIconWithDisplayName(FiCloudOff, "FiCloudOff"),
    wrapIconWithDisplayName(FiCloudRain, "FiCloudRain"),
    wrapIconWithDisplayName(FiCloudSnow, "FiCloudSnow"),
    wrapIconWithDisplayName(FiCloud, "FiCloud"),
    wrapIconWithDisplayName(FiCode, "FiCode"),
    wrapIconWithDisplayName(FiCodepen, "FiCodepen"),
    wrapIconWithDisplayName(FiCodesandbox, "FiCodesandbox"),
    wrapIconWithDisplayName(FiCoffee, "FiCoffee"),
    wrapIconWithDisplayName(FiColumns, "FiColumns"),
    wrapIconWithDisplayName(FiCommand, "FiCommand"),
    wrapIconWithDisplayName(FiCompass, "FiCompass"),
    wrapIconWithDisplayName(FiCopy, "FiCopy"),
    wrapIconWithDisplayName(FiCornerDownLeft, "FiCornerDownLeft"),
    wrapIconWithDisplayName(FiCornerDownRight, "FiCornerDownRight"),
    wrapIconWithDisplayName(FiCornerLeftDown, "FiCornerLeftDown"),
    wrapIconWithDisplayName(FiCornerLeftUp, "FiCornerLeftUp"),
    wrapIconWithDisplayName(FiCornerRightDown, "FiCornerRightDown"),
    wrapIconWithDisplayName(FiCornerRightUp, "FiCornerRightUp"),
    wrapIconWithDisplayName(FiCornerUpLeft, "FiCornerUpLeft"),
    wrapIconWithDisplayName(FiCornerUpRight, "FiCornerUpRight"),
    wrapIconWithDisplayName(FiCpu, "FiCpu"),
    wrapIconWithDisplayName(FiCreditCard, "FiCreditCard"),
    wrapIconWithDisplayName(FiCrop, "FiCrop"),
    wrapIconWithDisplayName(FiCrosshair, "FiCrosshair"),
    wrapIconWithDisplayName(FiDatabase, "FiDatabase"),
    wrapIconWithDisplayName(FiDelete, "FiDelete"),
    wrapIconWithDisplayName(FiDisc, "FiDisc"),
    wrapIconWithDisplayName(FiDivideCircle, "FiDivideCircle"),
    wrapIconWithDisplayName(FiDivideSquare, "FiDivideSquare"),
    wrapIconWithDisplayName(FiDivide, "FiDivide"),
    wrapIconWithDisplayName(FiDollarSign, "FiDollarSign"),
    wrapIconWithDisplayName(FiDownload, "FiDownload"),
    wrapIconWithDisplayName(FiDroplet, "FiDroplet"),
    wrapIconWithDisplayName(FiEdit2, "FiEdit2"),
    wrapIconWithDisplayName(FiEdit3, "FiEdit3"),
    wrapIconWithDisplayName(FiEdit, "FiEdit"),
    wrapIconWithDisplayName(FiExternalLink, "FiExternalLink"),
    wrapIconWithDisplayName(FiEyeOff, "FiEyeOff"),
    wrapIconWithDisplayName(FiEye, "FiEye"),
    wrapIconWithDisplayName(FiFacebook, "FiFacebook"),
    wrapIconWithDisplayName(FiFastForward, "FiFastForward"),
    wrapIconWithDisplayName(FiFeather, "FiFeather"),
    wrapIconWithDisplayName(FiFigma, "FiFigma"),
    wrapIconWithDisplayName(FiFileMinus, "FiFileMinus"),
    wrapIconWithDisplayName(FiFilePlus, "FiFilePlus"),
    wrapIconWithDisplayName(FiFileText, "FiFileText"),
    wrapIconWithDisplayName(FiFile, "FiFile"),
    wrapIconWithDisplayName(FiFilm, "FiFilm"),
    wrapIconWithDisplayName(FiFilter, "FiFilter"),
    wrapIconWithDisplayName(FiFlag, "FiFlag"),
    wrapIconWithDisplayName(FiFolderMinus, "FiFolderMinus"),
    wrapIconWithDisplayName(FiFolderPlus, "FiFolderPlus"),
    wrapIconWithDisplayName(FiFolder, "FiFolder"),
    wrapIconWithDisplayName(FiFramer, "FiFramer"),
    wrapIconWithDisplayName(FiFrown, "FiFrown"),
    wrapIconWithDisplayName(FiGift, "FiGift"),
    wrapIconWithDisplayName(FiGitBranch, "FiGitBranch"),
    wrapIconWithDisplayName(FiGitCommit, "FiGitCommit"),
    wrapIconWithDisplayName(FiGitMerge, "FiGitMerge"),
    wrapIconWithDisplayName(FiGitPullRequest, "FiGitPullRequest"),
    wrapIconWithDisplayName(FiGithub, "FiGithub"),
    wrapIconWithDisplayName(FiGitlab, "FiGitlab"),
    wrapIconWithDisplayName(FiGlobe, "FiGlobe"),
    wrapIconWithDisplayName(FiGrid, "FiGrid"),
    wrapIconWithDisplayName(FiHardDrive, "FiHardDrive"),
    wrapIconWithDisplayName(FiHash, "FiHash"),
    wrapIconWithDisplayName(FiHeadphones, "FiHeadphones"),
    wrapIconWithDisplayName(FiHeart, "FiHeart"),
    wrapIconWithDisplayName(FiHelpCircle, "FiHelpCircle"),
    wrapIconWithDisplayName(FiHexagon, "FiHexagon"),
    wrapIconWithDisplayName(FiHome, "FiHome"),
    wrapIconWithDisplayName(FiImage, "FiImage"),
    wrapIconWithDisplayName(FiInbox, "FiInbox"),
    wrapIconWithDisplayName(FiInfo, "FiInfo"),
    wrapIconWithDisplayName(FiInstagram, "FiInstagram"),
    wrapIconWithDisplayName(FiItalic, "FiItalic"),
    wrapIconWithDisplayName(FiKey, "FiKey"),
    wrapIconWithDisplayName(FiLayers, "FiLayers"),
    wrapIconWithDisplayName(FiLayout, "FiLayout"),
    wrapIconWithDisplayName(FiLifeBuoy, "FiLifeBuoy"),
    wrapIconWithDisplayName(FiLink2, "FiLink2"),
    wrapIconWithDisplayName(FiLink, "FiLink"),
    wrapIconWithDisplayName(FiLinkedin, "FiLinkedin"),
    wrapIconWithDisplayName(FiList, "FiList"),
    wrapIconWithDisplayName(FiLoader, "FiLoader"),
    wrapIconWithDisplayName(FiLock, "FiLock"),
    wrapIconWithDisplayName(FiLogIn, "FiLogIn"),
    wrapIconWithDisplayName(FiLogOut, "FiLogOut"),
    wrapIconWithDisplayName(FiMail, "FiMail"),
    wrapIconWithDisplayName(FiMapPin, "FiMapPin"),
    wrapIconWithDisplayName(FiMap, "FiMap"),
    wrapIconWithDisplayName(FiMaximize2, "FiMaximize2"),
    wrapIconWithDisplayName(FiMaximize, "FiMaximize"),
    wrapIconWithDisplayName(FiMeh, "FiMeh"),
    wrapIconWithDisplayName(FiMenu, "FiMenu"),
    wrapIconWithDisplayName(FiMessageCircle, "FiMessageCircle"),
    wrapIconWithDisplayName(FiMessageSquare, "FiMessageSquare"),
    wrapIconWithDisplayName(FiMicOff, "FiMicOff"),
    wrapIconWithDisplayName(FiMic, "FiMic"),
    wrapIconWithDisplayName(FiMinimize2, "FiMinimize2"),
    wrapIconWithDisplayName(FiMinimize, "FiMinimize"),
    wrapIconWithDisplayName(FiMinusCircle, "FiMinusCircle"),
    wrapIconWithDisplayName(FiMinusSquare, "FiMinusSquare"),
    wrapIconWithDisplayName(FiMinus, "FiMinus"),
    wrapIconWithDisplayName(FiMonitor, "FiMonitor"),
    wrapIconWithDisplayName(FiMoon, "FiMoon"),
    wrapIconWithDisplayName(FiMoreHorizontal, "FiMoreHorizontal"),
    wrapIconWithDisplayName(FiMoreVertical, "FiMoreVertical"),
    wrapIconWithDisplayName(FiMousePointer, "FiMousePointer"),
    wrapIconWithDisplayName(FiMove, "FiMove"),
    wrapIconWithDisplayName(FiMusic, "FiMusic"),
    wrapIconWithDisplayName(FiNavigation2, "FiNavigation2"),
    wrapIconWithDisplayName(FiNavigation, "FiNavigation"),
    wrapIconWithDisplayName(FiOctagon, "FiOctagon"),
    wrapIconWithDisplayName(FiPackage, "FiPackage"),
    wrapIconWithDisplayName(FiPaperclip, "FiPaperclip"),
    wrapIconWithDisplayName(FiPauseCircle, "FiPauseCircle"),
    wrapIconWithDisplayName(FiPause, "FiPause"),
    wrapIconWithDisplayName(FiPenTool, "FiPenTool"),
    wrapIconWithDisplayName(FiPercent, "FiPercent"),
    wrapIconWithDisplayName(FiPhoneCall, "FiPhoneCall"),
    wrapIconWithDisplayName(FiPhoneForwarded, "FiPhoneForwarded"),
    wrapIconWithDisplayName(FiPhoneIncoming, "FiPhoneIncoming"),
    wrapIconWithDisplayName(FiPhoneMissed, "FiPhoneMissed"),
    wrapIconWithDisplayName(FiPhoneOff, "FiPhoneOff"),
    wrapIconWithDisplayName(FiPhoneOutgoing, "FiPhoneOutgoing"),
    wrapIconWithDisplayName(FiPhone, "FiPhone"),
    wrapIconWithDisplayName(FiPieChart, "FiPieChart"),
    wrapIconWithDisplayName(FiPlayCircle, "FiPlayCircle"),
    wrapIconWithDisplayName(FiPlay, "FiPlay"),
    wrapIconWithDisplayName(FiPlusCircle, "FiPlusCircle"),
    wrapIconWithDisplayName(FiPlusSquare, "FiPlusSquare"),
    wrapIconWithDisplayName(FiPlus, "FiPlus"),
    wrapIconWithDisplayName(FiPocket, "FiPocket"),
    wrapIconWithDisplayName(FiPower, "FiPower"),
    wrapIconWithDisplayName(FiPrinter, "FiPrinter"),
    wrapIconWithDisplayName(FiRadio, "FiRadio"),
    wrapIconWithDisplayName(FiRefreshCcw, "FiRefreshCcw"),
    wrapIconWithDisplayName(FiRefreshCw, "FiRefreshCw"),
    wrapIconWithDisplayName(FiRepeat, "FiRepeat"),
    wrapIconWithDisplayName(FiRewind, "FiRewind"),
    wrapIconWithDisplayName(FiRotateCcw, "FiRotateCcw"),
    wrapIconWithDisplayName(FiRotateCw, "FiRotateCw"),
    wrapIconWithDisplayName(FiRss, "FiRss"),
    wrapIconWithDisplayName(FiSave, "FiSave"),
    wrapIconWithDisplayName(FiScissors, "FiScissors"),
    wrapIconWithDisplayName(FiSearch, "FiSearch"),
    wrapIconWithDisplayName(FiSend, "FiSend"),
    wrapIconWithDisplayName(FiServer, "FiServer"),
    wrapIconWithDisplayName(FiSettings, "FiSettings"),
    wrapIconWithDisplayName(FiShare2, "FiShare2"),
    wrapIconWithDisplayName(FiShare, "FiShare"),
    wrapIconWithDisplayName(FiShieldOff, "FiShieldOff"),
    wrapIconWithDisplayName(FiShield, "FiShield"),
    wrapIconWithDisplayName(FiShoppingBag, "FiShoppingBag"),
    wrapIconWithDisplayName(FiShoppingCart, "FiShoppingCart"),
    wrapIconWithDisplayName(FiShuffle, "FiShuffle"),
    wrapIconWithDisplayName(FiSidebar, "FiSidebar"),
    wrapIconWithDisplayName(FiSkipBack, "FiSkipBack"),
    wrapIconWithDisplayName(FiSkipForward, "FiSkipForward"),
    wrapIconWithDisplayName(FiSlack, "FiSlack"),
    wrapIconWithDisplayName(FiSlash, "FiSlash"),
    wrapIconWithDisplayName(FiSliders, "FiSliders"),
    wrapIconWithDisplayName(FiSmartphone, "FiSmartphone"),
    wrapIconWithDisplayName(FiSmile, "FiSmile"),
    wrapIconWithDisplayName(FiSpeaker, "FiSpeaker"),
    wrapIconWithDisplayName(FiSquare, "FiSquare"),
    wrapIconWithDisplayName(FiStar, "FiStar"),
    wrapIconWithDisplayName(FiStopCircle, "FiStopCircle"),
    wrapIconWithDisplayName(FiSun, "FiSun"),
    wrapIconWithDisplayName(FiSunrise, "FiSunrise"),
    wrapIconWithDisplayName(FiSunset, "FiSunset"),
    wrapIconWithDisplayName(FiTablet, "FiTablet"),
    wrapIconWithDisplayName(FiTag, "FiTag"),
    wrapIconWithDisplayName(FiTarget, "FiTarget"),
    wrapIconWithDisplayName(FiTerminal, "FiTerminal"),
    wrapIconWithDisplayName(FiThermometer, "FiThermometer"),
    wrapIconWithDisplayName(FiThumbsDown, "FiThumbsDown"),
    wrapIconWithDisplayName(FiThumbsUp, "FiThumbsUp"),
    wrapIconWithDisplayName(FiToggleLeft, "FiToggleLeft"),
    wrapIconWithDisplayName(FiToggleRight, "FiToggleRight"),
    wrapIconWithDisplayName(FiTool, "FiTool"),
    wrapIconWithDisplayName(FiTrash2, "FiTrash2"),
    wrapIconWithDisplayName(FiTrash, "FiTrash"),
    wrapIconWithDisplayName(FiTrello, "FiTrello"),
    wrapIconWithDisplayName(FiTrendingDown, "FiTrendingDown"),
    wrapIconWithDisplayName(FiTrendingUp, "FiTrendingUp"),
    wrapIconWithDisplayName(FiTriangle, "FiTriangle"),
    wrapIconWithDisplayName(FiTruck, "FiTruck"),
    wrapIconWithDisplayName(FiTv, "FiTv"),
    wrapIconWithDisplayName(FiTwitch, "FiTwitch"),
    wrapIconWithDisplayName(FiTwitter, "FiTwitter"),
    wrapIconWithDisplayName(FiType, "FiType"),
    wrapIconWithDisplayName(FiUmbrella, "FiUmbrella"),
    wrapIconWithDisplayName(FiUnderline, "FiUnderline"),
    wrapIconWithDisplayName(FiUnlock, "FiUnlock"),
    wrapIconWithDisplayName(FiUploadCloud, "FiUploadCloud"),
    wrapIconWithDisplayName(FiUpload, "FiUpload"),
    wrapIconWithDisplayName(FiUserCheck, "FiUserCheck"),
    wrapIconWithDisplayName(FiUserMinus, "FiUserMinus"),
    wrapIconWithDisplayName(FiUserPlus, "FiUserPlus"),
    wrapIconWithDisplayName(FiUserX, "FiUserX"),
    wrapIconWithDisplayName(FiUser, "FiUser"),
    wrapIconWithDisplayName(FiUsers, "FiUsers"),
    wrapIconWithDisplayName(FiVideoOff, "FiVideoOff"),
    wrapIconWithDisplayName(FiVideo, "FiVideo"),
    wrapIconWithDisplayName(FiVoicemail, "FiVoicemail"),
    wrapIconWithDisplayName(FiVolume1, "FiVolume1"),
    wrapIconWithDisplayName(FiVolume2, "FiVolume2"),
    wrapIconWithDisplayName(FiVolumeX, "FiVolumeX"),
    wrapIconWithDisplayName(FiVolume, "FiVolume"),
    wrapIconWithDisplayName(FiWatch, "FiWatch"),
    wrapIconWithDisplayName(FiWifiOff, "FiWifiOff"),
    wrapIconWithDisplayName(FiWifi, "FiWifi"),
    wrapIconWithDisplayName(FiWind, "FiWind"),
    wrapIconWithDisplayName(FiXCircle, "FiXCircle"),
    wrapIconWithDisplayName(FiXOctagon, "FiXOctagon"),
    wrapIconWithDisplayName(FiXSquare, "FiXSquare"),
    wrapIconWithDisplayName(FiX, "FiX"),
    wrapIconWithDisplayName(FiYoutube, "FiYoutube"),
    wrapIconWithDisplayName(FiZapOff, "FiZapOff"),
    wrapIconWithDisplayName(FiZap, "FiZap"),
    wrapIconWithDisplayName(FiZoomIn, "FiZoomIn"),
    wrapIconWithDisplayName(FiZoomOut, "FiZoomOut"),
  ],
  Brands: [
    wrapIconWithDisplayName(SiAdobe, "SiAdobe"),
    wrapIconWithDisplayName(SiAmazon, "SiAmazon"),
    wrapIconWithDisplayName(SiAndroid, "SiAndroid"),
    wrapIconWithDisplayName(SiAngular, "SiAngular"),
    wrapIconWithDisplayName(SiApple, "SiApple"),
    wrapIconWithDisplayName(SiAzuredevops, "SiAzuredevops"),
    wrapIconWithDisplayName(SiBabel, "SiBabel"),
    wrapIconWithDisplayName(SiBootstrap, "SiBootstrap"),
    wrapIconWithDisplayName(SiCsharp, "SiCsharp"),
    wrapIconWithDisplayName(SiCss3, "SiCss3"),
    wrapIconWithDisplayName(SiDjango, "SiDjango"),
    wrapIconWithDisplayName(SiDocker, "SiDocker"),
    wrapIconWithDisplayName(SiFacebook, "SiFacebook"),
    wrapIconWithDisplayName(SiFirefox, "SiFirefox"),
    wrapIconWithDisplayName(SiFlutter, "SiFlutter"),
    wrapIconWithDisplayName(SiFoursquare, "SiFoursquare"),
    wrapIconWithDisplayName(SiGit, "SiGit"),
    wrapIconWithDisplayName(SiGithub, "SiGithub"),
    wrapIconWithDisplayName(SiGitlab, "SiGitlab"),
    wrapIconWithDisplayName(SiGooglechrome, "SiGooglechrome"),
    wrapIconWithDisplayName(SiHeroku, "SiHeroku"),
    wrapIconWithDisplayName(SiHtml5, "SiHtml5"),
    wrapIconWithDisplayName(SiIntellijidea, "SiIntellijidea"),
    wrapIconWithDisplayName(SiJavascript, "SiJavascript"),
    wrapIconWithDisplayName(SiJenkins, "SiJenkins"),
    wrapIconWithDisplayName(SiJquery, "SiJquery"),
    wrapIconWithDisplayName(SiKubernetes, "SiKubernetes"),
    wrapIconWithDisplayName(SiLinkedin, "SiLinkedin"),
    wrapIconWithDisplayName(SiLinux, "SiLinux"),
    wrapIconWithDisplayName(SiMongodb, "SiMongodb"),
    wrapIconWithDisplayName(SiMysql, "SiMysql"),
    wrapIconWithDisplayName(SiNativescript, "SiNativescript"),
    wrapIconWithDisplayName(SiNetlify, "SiNetlify"),
    wrapIconWithDisplayName(SiNpm, "SiNpm"),
    wrapIconWithDisplayName(SiOracle, "SiOracle"),
    wrapIconWithDisplayName(SiPhp, "SiPhp"),
    wrapIconWithDisplayName(SiPostgresql, "SiPostgresql"),
    wrapIconWithDisplayName(SiPython, "SiPython"),
    wrapIconWithDisplayName(SiReact, "SiReact"),
    wrapIconWithDisplayName(SiRedis, "SiRedis"),
    wrapIconWithDisplayName(SiRedux, "SiRedux"),
    wrapIconWithDisplayName(SiRuby, "SiRuby"),
    wrapIconWithDisplayName(SiRust, "SiRust"),
    wrapIconWithDisplayName(SiSass, "SiSass"),
    wrapIconWithDisplayName(SiStackoverflow, "SiStackoverflow"),
    wrapIconWithDisplayName(SiTwitter, "SiTwitter"),
    wrapIconWithDisplayName(SiTypescript, "SiTypescript"),
    wrapIconWithDisplayName(SiVercel, "SiVercel"),
    wrapIconWithDisplayName(SiVisualstudio, "SiVisualstudio"),
    wrapIconWithDisplayName(SiWebpack, "SiWebpack"),
    wrapIconWithDisplayName(SiWordpress, "SiWordpress"),
    wrapIconWithDisplayName(SiYarn, "SiYarn"),
  ],
  Solid: [
    wrapIconWithDisplayName(FaBeer, "FaBeer"),
    wrapIconWithDisplayName(FaCoffee, "FaCoffee"),
    wrapIconWithDisplayName(FaAppleAlt, "FaAppleAlt"),
    wrapIconWithDisplayName(FaCarrot, "FaCarrot"),
    wrapIconWithDisplayName(FaAmbulance, "FaAmbulance"),
    wrapIconWithDisplayName(FaAnchor, "FaAnchor"),
    wrapIconWithDisplayName(FaArchway, "FaArchway"),
    wrapIconWithDisplayName(FaAtlas, "FaAtlas"),
    wrapIconWithDisplayName(FaAtom, "FaAtom"),
    wrapIconWithDisplayName(FaAward, "FaAward"),
    wrapIconWithDisplayName(FaBaby, "FaBaby"),
    wrapIconWithDisplayName(FaBacon, "FaBacon"),
    wrapIconWithDisplayName(FaBahai, "FaBahai"),
    wrapIconWithDisplayName(FaBalanceScale, "FaBalanceScale"),
    wrapIconWithDisplayName(FaBan, "FaBan"),
    wrapIconWithDisplayName(FaBandAid, "FaBandAid"),
    wrapIconWithDisplayName(FaBarcode, "FaBarcode"),
    wrapIconWithDisplayName(FaBars, "FaBars"),
    wrapIconWithDisplayName(FaBaseballBall, "FaBaseballBall"),
    wrapIconWithDisplayName(FaBasketballBall, "FaBasketballBall"),
    wrapIconWithDisplayName(FaBath, "FaBath"),
    wrapIconWithDisplayName(FaBatteryFull, "FaBatteryFull"),
    wrapIconWithDisplayName(FaBed, "FaBed"),
    wrapIconWithDisplayName(FaBell, "FaBell"),
    wrapIconWithDisplayName(FaBicycle, "FaBicycle"),
    wrapIconWithDisplayName(FaBinoculars, "FaBinoculars"),
    wrapIconWithDisplayName(FaBiohazard, "FaBiohazard"),
    wrapIconWithDisplayName(FaBirthdayCake, "FaBirthdayCake"),
    wrapIconWithDisplayName(FaBlender, "FaBlender"),
    wrapIconWithDisplayName(FaBolt, "FaBolt"),
    wrapIconWithDisplayName(FaBomb, "FaBomb"),
    wrapIconWithDisplayName(FaBone, "FaBone"),
    wrapIconWithDisplayName(FaBook, "FaBook"),
    wrapIconWithDisplayName(FaBookmark, "FaBookmark"),
    wrapIconWithDisplayName(FaBowlingBall, "FaBowlingBall"),
    wrapIconWithDisplayName(FaBox, "FaBox"),
    wrapIconWithDisplayName(FaBrain, "FaBrain"),
    wrapIconWithDisplayName(FaBreadSlice, "FaBreadSlice"),
    wrapIconWithDisplayName(FaBriefcase, "FaBriefcase"),
    wrapIconWithDisplayName(FaBroadcastTower, "FaBroadcastTower"),
    wrapIconWithDisplayName(FaBroom, "FaBroom"),
    wrapIconWithDisplayName(FaBrush, "FaBrush"),
    wrapIconWithDisplayName(FaBug, "FaBug"),
    wrapIconWithDisplayName(FaBuilding, "FaBuilding"),
    wrapIconWithDisplayName(FaBullhorn, "FaBullhorn"),
    wrapIconWithDisplayName(FaBullseye, "FaBullseye"),
    wrapIconWithDisplayName(FaBurn, "FaBurn"),
    wrapIconWithDisplayName(FaBus, "FaBus"),
    wrapIconWithDisplayName(FaCalculator, "FaCalculator"),
    wrapIconWithDisplayName(FaCalendar, "FaCalendar"),
    wrapIconWithDisplayName(FaCamera, "FaCamera"),
    wrapIconWithDisplayName(FaCandyCane, "FaCandyCane"),
    wrapIconWithDisplayName(FaCapsules, "FaCapsules"),
    wrapIconWithDisplayName(FaCar, "FaCar"),
    wrapIconWithDisplayName(FaCat, "FaCat"),
    wrapIconWithDisplayName(FaCertificate, "FaCertificate"),
    wrapIconWithDisplayName(FaChair, "FaChair"),
    wrapIconWithDisplayName(FaChalkboard, "FaChalkboard"),
    wrapIconWithDisplayName(FaChartBar, "FaChartBar"),
    wrapIconWithDisplayName(FaChartLine, "FaChartLine"),
    wrapIconWithDisplayName(FaChartPie, "FaChartPie"),
    wrapIconWithDisplayName(FaChess, "FaChess"),
    wrapIconWithDisplayName(FaChild, "FaChild"),
    wrapIconWithDisplayName(FaChurch, "FaChurch"),
    wrapIconWithDisplayName(FaCircle, "FaCircle"),
    wrapIconWithDisplayName(FaClipboard, "FaClipboard"),
    wrapIconWithDisplayName(FaClock, "FaClock"),
    wrapIconWithDisplayName(FaClone, "FaClone"),
    wrapIconWithDisplayName(FaClosedCaptioning, "FaClosedCaptioning"),
    wrapIconWithDisplayName(FaCloud, "FaCloud"),
    wrapIconWithDisplayName(FaCocktail, "FaCocktail"),
    wrapIconWithDisplayName(FaCode, "FaCode"),
    wrapIconWithDisplayName(FaCog, "FaCog"),
    wrapIconWithDisplayName(FaCogs, "FaCogs"),
    wrapIconWithDisplayName(FaCoins, "FaCoins"),
    wrapIconWithDisplayName(FaColumns, "FaColumns"),
    wrapIconWithDisplayName(FaComment, "FaComment"),
    wrapIconWithDisplayName(FaCompass, "FaCompass"),
    wrapIconWithDisplayName(FaCompress, "FaCompress"),
    wrapIconWithDisplayName(FaConciergeBell, "FaConciergeBell"),
    wrapIconWithDisplayName(FaCookie, "FaCookie"),
    wrapIconWithDisplayName(FaCopy, "FaCopy"),
    wrapIconWithDisplayName(FaCopyright, "FaCopyright"),
    wrapIconWithDisplayName(FaCouch, "FaCouch"),
    wrapIconWithDisplayName(FaCreditCard, "FaCreditCard"),
    wrapIconWithDisplayName(FaCrop, "FaCrop"),
    wrapIconWithDisplayName(FaCross, "FaCross"),
    wrapIconWithDisplayName(FaCrosshairs, "FaCrosshairs"),
    wrapIconWithDisplayName(FaCrow, "FaCrow"),
    wrapIconWithDisplayName(FaCrown, "FaCrown"),
    wrapIconWithDisplayName(FaCube, "FaCube"),
    wrapIconWithDisplayName(FaCut, "FaCut"),
    wrapIconWithDisplayName(FaDatabase, "FaDatabase"),
    wrapIconWithDisplayName(FaDeaf, "FaDeaf"),
    wrapIconWithDisplayName(FaDemocrat, "FaDemocrat"),
    wrapIconWithDisplayName(FaDesktop, "FaDesktop"),
    wrapIconWithDisplayName(FaDharmachakra, "FaDharmachakra"),
    wrapIconWithDisplayName(FaDiagnoses, "FaDiagnoses"),
    wrapIconWithDisplayName(FaDice, "FaDice"),
    wrapIconWithDisplayName(FaDigitalTachograph, "FaDigitalTachograph"),
    wrapIconWithDisplayName(FaDirections, "FaDirections"),
    wrapIconWithDisplayName(FaDisease, "FaDisease"),
    wrapIconWithDisplayName(FaDivide, "FaDivide"),
    wrapIconWithDisplayName(FaDna, "FaDna"),
    wrapIconWithDisplayName(FaDog, "FaDog"),
    wrapIconWithDisplayName(FaDollarSign, "FaDollarSign"),
    wrapIconWithDisplayName(FaDolly, "FaDolly"),
    wrapIconWithDisplayName(FaDoorClosed, "FaDoorClosed"),
    wrapIconWithDisplayName(FaDove, "FaDove"),
    wrapIconWithDisplayName(FaDownload, "FaDownload"),
    wrapIconWithDisplayName(FaDraftingCompass, "FaDraftingCompass"),
    wrapIconWithDisplayName(FaDragon, "FaDragon"),
    wrapIconWithDisplayName(FaDrum, "FaDrum"),
    wrapIconWithDisplayName(FaDrumstickBite, "FaDrumstickBite"),
    wrapIconWithDisplayName(FaDumbbell, "FaDumbbell"),
    wrapIconWithDisplayName(FaDumpsterFire, "FaDumpsterFire"),
    wrapIconWithDisplayName(FaDungeon, "FaDungeon"),
    wrapIconWithDisplayName(FaEdit, "FaEdit"),
    wrapIconWithDisplayName(FaEgg, "FaEgg"),
    wrapIconWithDisplayName(FaEject, "FaEject"),
    wrapIconWithDisplayName(FaEllipsisH, "FaEllipsisH"),
    wrapIconWithDisplayName(FaEllipsisV, "FaEllipsisV"),
    wrapIconWithDisplayName(FaEnvelope, "FaEnvelope"),
    wrapIconWithDisplayName(FaEraser, "FaEraser"),
    wrapIconWithDisplayName(FaEthernet, "FaEthernet"),
    wrapIconWithDisplayName(FaEuroSign, "FaEuroSign"),
    wrapIconWithDisplayName(FaExchangeAlt, "FaExchangeAlt"),
    wrapIconWithDisplayName(FaExclamation, "FaExclamation"),
    wrapIconWithDisplayName(FaExclamationCircle, "FaExclamationCircle"),
    wrapIconWithDisplayName(FaExclamationTriangle, "FaExclamationTriangle"),
    wrapIconWithDisplayName(FaExpand, "FaExpand"),
    wrapIconWithDisplayName(FaExpandArrowsAlt, "FaExpandArrowsAlt"),
    wrapIconWithDisplayName(FaExternalLinkAlt, "FaExternalLinkAlt"),
    wrapIconWithDisplayName(FaEye, "FaEye"),
    wrapIconWithDisplayName(FaEyeDropper, "FaEyeDropper"),
    wrapIconWithDisplayName(FaFan, "FaFan"),
    wrapIconWithDisplayName(FaFastBackward, "FaFastBackward"),
    wrapIconWithDisplayName(FaFastForward, "FaFastForward"),
    wrapIconWithDisplayName(FaFaucet, "FaFaucet"),
    wrapIconWithDisplayName(FaFax, "FaFax"),
    wrapIconWithDisplayName(FaFeather, "FaFeather"),
    wrapIconWithDisplayName(FaFeatherAlt, "FaFeatherAlt"),
    wrapIconWithDisplayName(FaFemale, "FaFemale"),
    wrapIconWithDisplayName(FaFighterJet, "FaFighterJet"),
    wrapIconWithDisplayName(FaFile, "FaFile"),
    wrapIconWithDisplayName(FaFileAlt, "FaFileAlt"),
    wrapIconWithDisplayName(FaFilm, "FaFilm"),
    wrapIconWithDisplayName(FaFilter, "FaFilter"),
    wrapIconWithDisplayName(FaFingerprint, "FaFingerprint"),
    wrapIconWithDisplayName(FaFire, "FaFire"),
    wrapIconWithDisplayName(FaFireAlt, "FaFireAlt"),
    wrapIconWithDisplayName(FaFireExtinguisher, "FaFireExtinguisher"),
    wrapIconWithDisplayName(FaFirstAid, "FaFirstAid"),
    wrapIconWithDisplayName(FaFish, "FaFish"),
    wrapIconWithDisplayName(FaFlag, "FaFlag"),
    wrapIconWithDisplayName(FaFlask, "FaFlask"),
    wrapIconWithDisplayName(FaFlushed, "FaFlushed"),
    wrapIconWithDisplayName(FaFolder, "FaFolder"),
    wrapIconWithDisplayName(FaFont, "FaFont"),
    wrapIconWithDisplayName(FaFootballBall, "FaFootballBall"),
    wrapIconWithDisplayName(FaForward, "FaForward"),
    wrapIconWithDisplayName(FaFrog, "FaFrog"),
    wrapIconWithDisplayName(FaFrown, "FaFrown"),
    wrapIconWithDisplayName(FaFrownOpen, "FaFrownOpen"),
    wrapIconWithDisplayName(FaFunnelDollar, "FaFunnelDollar"),
    wrapIconWithDisplayName(FaFutbol, "FaFutbol"),
    wrapIconWithDisplayName(FaGamepad, "FaGamepad"),
    wrapIconWithDisplayName(FaGasPump, "FaGasPump"),
    wrapIconWithDisplayName(FaGavel, "FaGavel"),
    wrapIconWithDisplayName(FaGem, "FaGem"),
    wrapIconWithDisplayName(FaGenderless, "FaGenderless"),
    wrapIconWithDisplayName(FaGhost, "FaGhost"),
    wrapIconWithDisplayName(FaGift, "FaGift"),
    wrapIconWithDisplayName(FaGlassCheers, "FaGlassCheers"),
    wrapIconWithDisplayName(FaGlasses, "FaGlasses"),
    wrapIconWithDisplayName(FaGlobe, "FaGlobe"),
    wrapIconWithDisplayName(FaGolfBall, "FaGolfBall"),
    wrapIconWithDisplayName(FaGopuram, "FaGopuram"),
    wrapIconWithDisplayName(FaGraduationCap, "FaGraduationCap"),
    wrapIconWithDisplayName(FaGreaterThan, "FaGreaterThan"),
    wrapIconWithDisplayName(FaGreaterThanEqual, "FaGreaterThanEqual"),
    wrapIconWithDisplayName(FaGrin, "FaGrin"),
    wrapIconWithDisplayName(FaGrinAlt, "FaGrinAlt"),
    wrapIconWithDisplayName(FaGrinBeam, "FaGrinBeam"),
    wrapIconWithDisplayName(FaGrinHearts, "FaGrinHearts"),
    wrapIconWithDisplayName(FaGrinSquint, "FaGrinSquint"),
    wrapIconWithDisplayName(FaGrinStars, "FaGrinStars"),
    wrapIconWithDisplayName(FaGrinTears, "FaGrinTears"),
    wrapIconWithDisplayName(FaGrinTongue, "FaGrinTongue"),
    wrapIconWithDisplayName(FaGrinTongueWink, "FaGrinTongueWink"),
    wrapIconWithDisplayName(FaGrinWink, "FaGrinWink"),
    wrapIconWithDisplayName(FaGripHorizontal, "FaGripHorizontal"),
    wrapIconWithDisplayName(FaGripVertical, "FaGripVertical"),
    wrapIconWithDisplayName(FaGuitar, "FaGuitar"),
    wrapIconWithDisplayName(FaHSquare, "FaHSquare"),
    wrapIconWithDisplayName(FaHamburger, "FaHamburger"),
    wrapIconWithDisplayName(FaHammer, "FaHammer"),
    wrapIconWithDisplayName(FaHandHolding, "FaHandHolding"),
    wrapIconWithDisplayName(FaHandHoldingHeart, "FaHandHoldingHeart"),
    wrapIconWithDisplayName(FaHandHoldingUsd, "FaHandHoldingUsd"),
    wrapIconWithDisplayName(FaHandLizard, "FaHandLizard"),
    wrapIconWithDisplayName(FaHandMiddleFinger, "FaHandMiddleFinger"),
    wrapIconWithDisplayName(FaHandPaper, "FaHandPaper"),
    wrapIconWithDisplayName(FaHandPeace, "FaHandPeace"),
    wrapIconWithDisplayName(FaHandPointDown, "FaHandPointDown"),
    wrapIconWithDisplayName(FaHandPointLeft, "FaHandPointLeft"),
    wrapIconWithDisplayName(FaHandPointRight, "FaHandPointRight"),
    wrapIconWithDisplayName(FaHandPointUp, "FaHandPointUp"),
    wrapIconWithDisplayName(FaHandRock, "FaHandRock"),
    wrapIconWithDisplayName(FaHandScissors, "FaHandScissors"),
    wrapIconWithDisplayName(FaHandSparkles, "FaHandSparkles"),
    wrapIconWithDisplayName(FaHandSpock, "FaHandSpock"),
    wrapIconWithDisplayName(FaHands, "FaHands"),
    wrapIconWithDisplayName(FaHandsHelping, "FaHandsHelping"),
    wrapIconWithDisplayName(FaHandshake, "FaHandshake"),
    wrapIconWithDisplayName(FaHardHat, "FaHardHat"),
    wrapIconWithDisplayName(FaHashtag, "FaHashtag"),
    wrapIconWithDisplayName(FaHatCowboy, "FaHatCowboy"),
    wrapIconWithDisplayName(FaHatCowboySide, "FaHatCowboySide"),
    wrapIconWithDisplayName(FaHatWizard, "FaHatWizard"),
    wrapIconWithDisplayName(FaHdd, "FaHdd"),
    wrapIconWithDisplayName(FaHeading, "FaHeading"),
    wrapIconWithDisplayName(FaHeadphones, "FaHeadphones"),
    wrapIconWithDisplayName(FaHeadphonesAlt, "FaHeadphonesAlt"),
    wrapIconWithDisplayName(FaHeadset, "FaHeadset"),
    wrapIconWithDisplayName(FaHeart, "FaHeart"),
    wrapIconWithDisplayName(FaHeartBroken, "FaHeartBroken"),
    wrapIconWithDisplayName(FaHeartbeat, "FaHeartbeat"),
    wrapIconWithDisplayName(FaHelicopter, "FaHelicopter"),
    wrapIconWithDisplayName(FaHighlighter, "FaHighlighter"),
    wrapIconWithDisplayName(FaHiking, "FaHiking"),
    wrapIconWithDisplayName(FaHippo, "FaHippo"),
    wrapIconWithDisplayName(FaHistory, "FaHistory"),
    wrapIconWithDisplayName(FaHockeyPuck, "FaHockeyPuck"),
    wrapIconWithDisplayName(FaHollyBerry, "FaHollyBerry"),
    wrapIconWithDisplayName(FaHome, "FaHome"),
    wrapIconWithDisplayName(FaHorse, "FaHorse"),
    wrapIconWithDisplayName(FaHorseHead, "FaHorseHead"),
    wrapIconWithDisplayName(FaHospital, "FaHospital"),
    wrapIconWithDisplayName(FaHotTub, "FaHotTub"),
    wrapIconWithDisplayName(FaHotdog, "FaHotdog"),
    wrapIconWithDisplayName(FaHotel, "FaHotel"),
    wrapIconWithDisplayName(FaHourglass, "FaHourglass"),
    wrapIconWithDisplayName(FaHouseDamage, "FaHouseDamage"),
    wrapIconWithDisplayName(FaHryvnia, "FaHryvnia"),
    wrapIconWithDisplayName(FaICursor, "FaICursor"),
    wrapIconWithDisplayName(FaIceCream, "FaIceCream"),
    wrapIconWithDisplayName(FaIcons, "FaIcons"),
    wrapIconWithDisplayName(FaIgloo, "FaIgloo"),
    wrapIconWithDisplayName(FaImage, "FaImage"),
    wrapIconWithDisplayName(FaImages, "FaImages"),
    wrapIconWithDisplayName(FaInbox, "FaInbox"),
    wrapIconWithDisplayName(FaIndent, "FaIndent"),
    wrapIconWithDisplayName(FaIndustry, "FaIndustry"),
    wrapIconWithDisplayName(FaInfinity, "FaInfinity"),
    wrapIconWithDisplayName(FaInfo, "FaInfo"),
    wrapIconWithDisplayName(FaInfoCircle, "FaInfoCircle"),
    wrapIconWithDisplayName(FaItalic, "FaItalic"),
    wrapIconWithDisplayName(FaJedi, "FaJedi"),
    wrapIconWithDisplayName(FaJoint, "FaJoint"),
    wrapIconWithDisplayName(FaJournalWhills, "FaJournalWhills"),
    wrapIconWithDisplayName(FaKaaba, "FaKaaba"),
    wrapIconWithDisplayName(FaKey, "FaKey"),
    wrapIconWithDisplayName(FaKeyboard, "FaKeyboard"),
    wrapIconWithDisplayName(FaKhanda, "FaKhanda"),
    wrapIconWithDisplayName(FaKiss, "FaKiss"),
    wrapIconWithDisplayName(FaKissBeam, "FaKissBeam"),
    wrapIconWithDisplayName(FaKissWinkHeart, "FaKissWinkHeart"),
    wrapIconWithDisplayName(FaKiwiBird, "FaKiwiBird"),
    wrapIconWithDisplayName(FaLandmark, "FaLandmark"),
    wrapIconWithDisplayName(FaLanguage, "FaLanguage"),
    wrapIconWithDisplayName(FaLaptop, "FaLaptop"),
    wrapIconWithDisplayName(FaLaptopCode, "FaLaptopCode"),
    wrapIconWithDisplayName(FaLaptopMedical, "FaLaptopMedical"),
    wrapIconWithDisplayName(FaLaugh, "FaLaugh"),
    wrapIconWithDisplayName(FaLaughBeam, "FaLaughBeam"),
    wrapIconWithDisplayName(FaLaughSquint, "FaLaughSquint"),
    wrapIconWithDisplayName(FaLaughWink, "FaLaughWink"),
    wrapIconWithDisplayName(FaLayerGroup, "FaLayerGroup"),
    wrapIconWithDisplayName(FaLeaf, "FaLeaf"),
    wrapIconWithDisplayName(FaLemon, "FaLemon"),
    wrapIconWithDisplayName(FaLessThan, "FaLessThan"),
    wrapIconWithDisplayName(FaLessThanEqual, "FaLessThanEqual"),
    wrapIconWithDisplayName(FaLevelDownAlt, "FaLevelDownAlt"),
    wrapIconWithDisplayName(FaLevelUpAlt, "FaLevelUpAlt"),
    wrapIconWithDisplayName(FaLifeRing, "FaLifeRing"),
    wrapIconWithDisplayName(FaLightbulb, "FaLightbulb"),
    wrapIconWithDisplayName(FaLink, "FaLink"),
    wrapIconWithDisplayName(FaLiraSign, "FaLiraSign"),
    wrapIconWithDisplayName(FaList, "FaList"),
    wrapIconWithDisplayName(FaListAlt, "FaListAlt"),
    wrapIconWithDisplayName(FaListOl, "FaListOl"),
    wrapIconWithDisplayName(FaListUl, "FaListUl"),
    wrapIconWithDisplayName(FaLocationArrow, "FaLocationArrow"),
    wrapIconWithDisplayName(FaLock, "FaLock"),
    wrapIconWithDisplayName(FaLockOpen, "FaLockOpen"),
    wrapIconWithDisplayName(FaLongArrowAltDown, "FaLongArrowAltDown"),
    wrapIconWithDisplayName(FaLongArrowAltLeft, "FaLongArrowAltLeft"),
    wrapIconWithDisplayName(FaLongArrowAltRight, "FaLongArrowAltRight"),
    wrapIconWithDisplayName(FaLongArrowAltUp, "FaLongArrowAltUp"),
    wrapIconWithDisplayName(FaLowVision, "FaLowVision"),
    wrapIconWithDisplayName(FaLuggageCart, "FaLuggageCart"),
    wrapIconWithDisplayName(FaMagic, "FaMagic"),
    wrapIconWithDisplayName(FaMagnet, "FaMagnet"),
    wrapIconWithDisplayName(FaMailBulk, "FaMailBulk"),
    wrapIconWithDisplayName(FaMale, "FaMale"),
    wrapIconWithDisplayName(FaMap, "FaMap"),
    wrapIconWithDisplayName(FaMapMarked, "FaMapMarked"),
    wrapIconWithDisplayName(FaMapMarkedAlt, "FaMapMarkedAlt"),
    wrapIconWithDisplayName(FaMapPin, "FaMapPin"),
    wrapIconWithDisplayName(FaMapSigns, "FaMapSigns"),
    wrapIconWithDisplayName(FaMarker, "FaMarker"),
    wrapIconWithDisplayName(FaMars, "FaMars"),
    wrapIconWithDisplayName(FaMarsDouble, "FaMarsDouble"),
    wrapIconWithDisplayName(FaMarsStroke, "FaMarsStroke"),
    wrapIconWithDisplayName(FaMarsStrokeH, "FaMarsStrokeH"),
    wrapIconWithDisplayName(FaMarsStrokeV, "FaMarsStrokeV"),
    wrapIconWithDisplayName(FaMask, "FaMask"),
    wrapIconWithDisplayName(FaMedal, "FaMedal"),
    wrapIconWithDisplayName(FaMedkit, "FaMedkit"),
    wrapIconWithDisplayName(FaMeh, "FaMeh"),
    wrapIconWithDisplayName(FaMehBlank, "FaMehBlank"),
    wrapIconWithDisplayName(FaMehRollingEyes, "FaMehRollingEyes"),
    wrapIconWithDisplayName(FaMemory, "FaMemory"),
    wrapIconWithDisplayName(FaMenorah, "FaMenorah"),
    wrapIconWithDisplayName(FaMercury, "FaMercury"),
    wrapIconWithDisplayName(FaMeteor, "FaMeteor"),
    wrapIconWithDisplayName(FaMicrochip, "FaMicrochip"),
    wrapIconWithDisplayName(FaMicrophone, "FaMicrophone"),
    wrapIconWithDisplayName(FaMicrophoneAlt, "FaMicrophoneAlt"),
    wrapIconWithDisplayName(FaMicrophoneAltSlash, "FaMicrophoneAltSlash"),
    wrapIconWithDisplayName(FaMicrophoneSlash, "FaMicrophoneSlash"),
    wrapIconWithDisplayName(FaMicroscope, "FaMicroscope"),
    wrapIconWithDisplayName(FaMinus, "FaMinus"),
    wrapIconWithDisplayName(FaMinusCircle, "FaMinusCircle"),
    wrapIconWithDisplayName(FaMinusSquare, "FaMinusSquare"),
    wrapIconWithDisplayName(FaMitten, "FaMitten"),
    wrapIconWithDisplayName(FaMobile, "FaMobile"),
    wrapIconWithDisplayName(FaMobileAlt, "FaMobileAlt"),
    wrapIconWithDisplayName(FaMoneyBill, "FaMoneyBill"),
    wrapIconWithDisplayName(FaMoneyBillAlt, "FaMoneyBillAlt"),
    wrapIconWithDisplayName(FaMoneyBillWave, "FaMoneyBillWave"),
    wrapIconWithDisplayName(FaMoneyBillWaveAlt, "FaMoneyBillWaveAlt"),
    wrapIconWithDisplayName(FaMoneyCheck, "FaMoneyCheck"),
    wrapIconWithDisplayName(FaMoneyCheckAlt, "FaMoneyCheckAlt"),
    wrapIconWithDisplayName(FaMonument, "FaMonument"),
    wrapIconWithDisplayName(FaMoon, "FaMoon"),
    wrapIconWithDisplayName(FaMortarPestle, "FaMortarPestle"),
    wrapIconWithDisplayName(FaMosque, "FaMosque"),
    wrapIconWithDisplayName(FaMotorcycle, "FaMotorcycle"),
    wrapIconWithDisplayName(FaMountain, "FaMountain"),
    wrapIconWithDisplayName(FaMouse, "FaMouse"),
    wrapIconWithDisplayName(FaMousePointer, "FaMousePointer"),
    wrapIconWithDisplayName(FaMugHot, "FaMugHot"),
    wrapIconWithDisplayName(FaMusic, "FaMusic"),
    wrapIconWithDisplayName(FaNetworkWired, "FaNetworkWired"),
    wrapIconWithDisplayName(FaNeuter, "FaNeuter"),
    wrapIconWithDisplayName(FaNewspaper, "FaNewspaper"),
    wrapIconWithDisplayName(FaNotEqual, "FaNotEqual"),
    wrapIconWithDisplayName(FaNotesMedical, "FaNotesMedical"),
    wrapIconWithDisplayName(FaObjectGroup, "FaObjectGroup"),
    wrapIconWithDisplayName(FaObjectUngroup, "FaObjectUngroup"),
    wrapIconWithDisplayName(FaOilCan, "FaOilCan"),
    wrapIconWithDisplayName(FaOm, "FaOm"),
    wrapIconWithDisplayName(FaOtter, "FaOtter"),
    wrapIconWithDisplayName(FaOutdent, "FaOutdent"),
    wrapIconWithDisplayName(FaPager, "FaPager"),
    wrapIconWithDisplayName(FaPaintBrush, "FaPaintBrush"),
    wrapIconWithDisplayName(FaPaintRoller, "FaPaintRoller"),
    wrapIconWithDisplayName(FaPalette, "FaPalette"),
    wrapIconWithDisplayName(FaPallet, "FaPallet"),
    wrapIconWithDisplayName(FaPaperPlane, "FaPaperPlane"),
    wrapIconWithDisplayName(FaPaperclip, "FaPaperclip"),
    wrapIconWithDisplayName(FaParachuteBox, "FaParachuteBox"),
    wrapIconWithDisplayName(FaParagraph, "FaParagraph"),
    wrapIconWithDisplayName(FaParking, "FaParking"),
    wrapIconWithDisplayName(FaPassport, "FaPassport"),
    wrapIconWithDisplayName(FaPastafarianism, "FaPastafarianism"),
    wrapIconWithDisplayName(FaPaste, "FaPaste"),
    wrapIconWithDisplayName(FaPause, "FaPause"),
    wrapIconWithDisplayName(FaPauseCircle, "FaPauseCircle"),
    wrapIconWithDisplayName(FaPaw, "FaPaw"),
    wrapIconWithDisplayName(FaPeace, "FaPeace"),
    wrapIconWithDisplayName(FaPen, "FaPen"),
    wrapIconWithDisplayName(FaPenAlt, "FaPenAlt"),
    wrapIconWithDisplayName(FaPenFancy, "FaPenFancy"),
    wrapIconWithDisplayName(FaPenNib, "FaPenNib"),
    wrapIconWithDisplayName(FaPenSquare, "FaPenSquare"),
    wrapIconWithDisplayName(FaPencilAlt, "FaPencilAlt"),
    wrapIconWithDisplayName(FaPencilRuler, "FaPencilRuler"),
    wrapIconWithDisplayName(FaPeopleCarry, "FaPeopleCarry"),
    wrapIconWithDisplayName(FaPepperHot, "FaPepperHot"),
    wrapIconWithDisplayName(FaPercent, "FaPercent"),
    wrapIconWithDisplayName(FaPercentage, "FaPercentage"),
    wrapIconWithDisplayName(FaPersonBooth, "FaPersonBooth"),
    wrapIconWithDisplayName(FaPhone, "FaPhone"),
    wrapIconWithDisplayName(FaPhoneAlt, "FaPhoneAlt"),
    wrapIconWithDisplayName(FaPhoneSlash, "FaPhoneSlash"),
    wrapIconWithDisplayName(FaPhoneSquare, "FaPhoneSquare"),
    wrapIconWithDisplayName(FaPhoneVolume, "FaPhoneVolume"),
    wrapIconWithDisplayName(FaPhotoVideo, "FaPhotoVideo"),
    wrapIconWithDisplayName(FaPiggyBank, "FaPiggyBank"),
    wrapIconWithDisplayName(FaPills, "FaPills"),
    wrapIconWithDisplayName(FaPizzaSlice, "FaPizzaSlice"),
    wrapIconWithDisplayName(FaPlaceOfWorship, "FaPlaceOfWorship"),
    wrapIconWithDisplayName(FaPlane, "FaPlane"),
    wrapIconWithDisplayName(FaPlaneArrival, "FaPlaneArrival"),
    wrapIconWithDisplayName(FaPlaneDeparture, "FaPlaneDeparture"),
    wrapIconWithDisplayName(FaPlay, "FaPlay"),
    wrapIconWithDisplayName(FaPlayCircle, "FaPlayCircle"),
    wrapIconWithDisplayName(FaPlug, "FaPlug"),
    wrapIconWithDisplayName(FaPlus, "FaPlus"),
    wrapIconWithDisplayName(FaPlusCircle, "FaPlusCircle"),
    wrapIconWithDisplayName(FaPlusSquare, "FaPlusSquare"),
    wrapIconWithDisplayName(FaPodcast, "FaPodcast"),
    wrapIconWithDisplayName(FaPoll, "FaPoll"),
    wrapIconWithDisplayName(FaPollH, "FaPollH"),
    wrapIconWithDisplayName(FaPoo, "FaPoo"),
    wrapIconWithDisplayName(FaPooStorm, "FaPooStorm"),
    wrapIconWithDisplayName(FaPoop, "FaPoop"),
    wrapIconWithDisplayName(FaPortrait, "FaPortrait"),
    wrapIconWithDisplayName(FaPoundSign, "FaPoundSign"),
    wrapIconWithDisplayName(FaPowerOff, "FaPowerOff"),
    wrapIconWithDisplayName(FaPray, "FaPray"),
    wrapIconWithDisplayName(FaPrayingHands, "FaPrayingHands"),
    wrapIconWithDisplayName(FaPrescription, "FaPrescription"),
    wrapIconWithDisplayName(FaPrescriptionBottle, "FaPrescriptionBottle"),
    wrapIconWithDisplayName(FaPrint, "FaPrint"),
    wrapIconWithDisplayName(FaProcedures, "FaProcedures"),
    wrapIconWithDisplayName(FaProjectDiagram, "FaProjectDiagram"),
    wrapIconWithDisplayName(FaPumpMedical, "FaPumpMedical"),
    wrapIconWithDisplayName(FaPumpSoap, "FaPumpSoap"),
    wrapIconWithDisplayName(FaPuzzlePiece, "FaPuzzlePiece"),
    wrapIconWithDisplayName(FaQrcode, "FaQrcode"),
    wrapIconWithDisplayName(FaQuestion, "FaQuestion"),
    wrapIconWithDisplayName(FaQuestionCircle, "FaQuestionCircle"),
    wrapIconWithDisplayName(FaQuidditch, "FaQuidditch"),
    wrapIconWithDisplayName(FaQuoteLeft, "FaQuoteLeft"),
    wrapIconWithDisplayName(FaQuoteRight, "FaQuoteRight"),
    wrapIconWithDisplayName(FaQuran, "FaQuran"),
    wrapIconWithDisplayName(FaRadiation, "FaRadiation"),
    wrapIconWithDisplayName(FaRadiationAlt, "FaRadiationAlt"),
    wrapIconWithDisplayName(FaRainbow, "FaRainbow"),
    wrapIconWithDisplayName(FaRandom, "FaRandom"),
    wrapIconWithDisplayName(FaReceipt, "FaReceipt"),
    wrapIconWithDisplayName(FaRecordVinyl, "FaRecordVinyl"),
    wrapIconWithDisplayName(FaRecycle, "FaRecycle"),
    wrapIconWithDisplayName(FaRedo, "FaRedo"),
    wrapIconWithDisplayName(FaRegistered, "FaRegistered"),
    wrapIconWithDisplayName(FaRemoveFormat, "FaRemoveFormat"),
    wrapIconWithDisplayName(FaReply, "FaReply"),
    wrapIconWithDisplayName(FaRepublican, "FaRepublican"),
    wrapIconWithDisplayName(FaRestroom, "FaRestroom"),
    wrapIconWithDisplayName(FaRetweet, "FaRetweet"),
    wrapIconWithDisplayName(FaRibbon, "FaRibbon"),
    wrapIconWithDisplayName(FaRing, "FaRing"),
    wrapIconWithDisplayName(FaRoad, "FaRoad"),
    wrapIconWithDisplayName(FaRobot, "FaRobot"),
    wrapIconWithDisplayName(FaRocket, "FaRocket"),
    wrapIconWithDisplayName(FaRoute, "FaRoute"),
    wrapIconWithDisplayName(FaRss, "FaRss"),
    wrapIconWithDisplayName(FaRssSquare, "FaRssSquare"),
    wrapIconWithDisplayName(FaRubleSign, "FaRubleSign"),
    wrapIconWithDisplayName(FaRuler, "FaRuler"),
    wrapIconWithDisplayName(FaRunning, "FaRunning"),
    wrapIconWithDisplayName(FaRupeeSign, "FaRupeeSign"),
    wrapIconWithDisplayName(FaSadCry, "FaSadCry"),
    wrapIconWithDisplayName(FaSadTear, "FaSadTear"),
    wrapIconWithDisplayName(FaSatellite, "FaSatellite"),
    wrapIconWithDisplayName(FaSatelliteDish, "FaSatelliteDish"),
    wrapIconWithDisplayName(FaSave, "FaSave"),
    wrapIconWithDisplayName(FaSchool, "FaSchool"),
    wrapIconWithDisplayName(FaScrewdriver, "FaScrewdriver"),
    wrapIconWithDisplayName(FaScroll, "FaScroll"),
    wrapIconWithDisplayName(FaSdCard, "FaSdCard"),
    wrapIconWithDisplayName(FaSearch, "FaSearch"),
    wrapIconWithDisplayName(FaSearchDollar, "FaSearchDollar"),
    wrapIconWithDisplayName(FaSearchLocation, "FaSearchLocation"),
    wrapIconWithDisplayName(FaSearchMinus, "FaSearchMinus"),
    wrapIconWithDisplayName(FaSearchPlus, "FaSearchPlus"),
    wrapIconWithDisplayName(FaSeedling, "FaSeedling"),
    wrapIconWithDisplayName(FaServer, "FaServer"),
    wrapIconWithDisplayName(FaShapes, "FaShapes"),
    wrapIconWithDisplayName(FaShare, "FaShare"),
    wrapIconWithDisplayName(FaShareAlt, "FaShareAlt"),
    wrapIconWithDisplayName(FaShareAltSquare, "FaShareAltSquare"),
    wrapIconWithDisplayName(FaShareSquare, "FaShareSquare"),
    wrapIconWithDisplayName(FaShekelSign, "FaShekelSign"),
    wrapIconWithDisplayName(FaShieldAlt, "FaShieldAlt"),
    wrapIconWithDisplayName(FaShip, "FaShip"),
    wrapIconWithDisplayName(FaShippingFast, "FaShippingFast"),
    wrapIconWithDisplayName(FaShoePrints, "FaShoePrints"),
    wrapIconWithDisplayName(FaShoppingBag, "FaShoppingBag"),
    wrapIconWithDisplayName(FaShoppingBasket, "FaShoppingBasket"),
    wrapIconWithDisplayName(FaShoppingCart, "FaShoppingCart"),
    wrapIconWithDisplayName(FaShower, "FaShower"),
    wrapIconWithDisplayName(FaShuttleVan, "FaShuttleVan"),
    wrapIconWithDisplayName(FaSign, "FaSign"),
    wrapIconWithDisplayName(FaSignInAlt, "FaSignInAlt"),
    wrapIconWithDisplayName(FaSignLanguage, "FaSignLanguage"),
    wrapIconWithDisplayName(FaSignOutAlt, "FaSignOutAlt"),
    wrapIconWithDisplayName(FaSignal, "FaSignal"),
    wrapIconWithDisplayName(FaSignature, "FaSignature"),
    wrapIconWithDisplayName(FaSimCard, "FaSimCard"),
    wrapIconWithDisplayName(FaSink, "FaSink"),
    wrapIconWithDisplayName(FaSitemap, "FaSitemap"),
    wrapIconWithDisplayName(FaSkating, "FaSkating"),
    wrapIconWithDisplayName(FaSkiing, "FaSkiing"),
    wrapIconWithDisplayName(FaSkiingNordic, "FaSkiingNordic"),
    wrapIconWithDisplayName(FaSkull, "FaSkull"),
    wrapIconWithDisplayName(FaSkullCrossbones, "FaSkullCrossbones"),
    wrapIconWithDisplayName(FaSlash, "FaSlash"),
    wrapIconWithDisplayName(FaSleigh, "FaSleigh"),
    wrapIconWithDisplayName(FaSlidersH, "FaSlidersH"),
    wrapIconWithDisplayName(FaSmile, "FaSmile"),
    wrapIconWithDisplayName(FaSmileBeam, "FaSmileBeam"),
    wrapIconWithDisplayName(FaSmileWink, "FaSmileWink"),
    wrapIconWithDisplayName(FaSmog, "FaSmog"),
    wrapIconWithDisplayName(FaSmoking, "FaSmoking"),
    wrapIconWithDisplayName(FaSms, "FaSms"),
    wrapIconWithDisplayName(FaSnowboarding, "FaSnowboarding"),
    wrapIconWithDisplayName(FaSnowflake, "FaSnowflake"),
    wrapIconWithDisplayName(FaSnowman, "FaSnowman"),
    wrapIconWithDisplayName(FaSnowplow, "FaSnowplow"),
    wrapIconWithDisplayName(FaSoap, "FaSoap"),
    wrapIconWithDisplayName(FaSocks, "FaSocks"),
    wrapIconWithDisplayName(FaSolarPanel, "FaSolarPanel"),
    wrapIconWithDisplayName(FaSort, "FaSort"),
    wrapIconWithDisplayName(FaSortAlphaDown, "FaSortAlphaDown"),
    wrapIconWithDisplayName(FaSortAlphaDownAlt, "FaSortAlphaDownAlt"),
    wrapIconWithDisplayName(FaSortAlphaUp, "FaSortAlphaUp"),
    wrapIconWithDisplayName(FaSortAlphaUpAlt, "FaSortAlphaUpAlt"),
    wrapIconWithDisplayName(FaSortAmountDown, "FaSortAmountDown"),
    wrapIconWithDisplayName(FaSortAmountDownAlt, "FaSortAmountDownAlt"),
    wrapIconWithDisplayName(FaSortAmountUp, "FaSortAmountUp"),
    wrapIconWithDisplayName(FaSortAmountUpAlt, "FaSortAmountUpAlt"),
    wrapIconWithDisplayName(FaSortDown, "FaSortDown"),
    wrapIconWithDisplayName(FaSortNumericDown, "FaSortNumericDown"),
    wrapIconWithDisplayName(FaSortNumericDownAlt, "FaSortNumericDownAlt"),
    wrapIconWithDisplayName(FaSortNumericUp, "FaSortNumericUp"),
    wrapIconWithDisplayName(FaSortNumericUpAlt, "FaSortNumericUpAlt"),
    wrapIconWithDisplayName(FaSortUp, "FaSortUp"),
    wrapIconWithDisplayName(FaSpa, "FaSpa"),
    wrapIconWithDisplayName(FaSpaceShuttle, "FaSpaceShuttle"),
    wrapIconWithDisplayName(FaSpellCheck, "FaSpellCheck"),
    wrapIconWithDisplayName(FaSpider, "FaSpider"),
    wrapIconWithDisplayName(FaSpinner, "FaSpinner"),
    wrapIconWithDisplayName(FaSplotch, "FaSplotch"),
    wrapIconWithDisplayName(FaSprayCan, "FaSprayCan"),
    wrapIconWithDisplayName(FaSquare, "FaSquare"),
    wrapIconWithDisplayName(FaSquareFull, "FaSquareFull"),
    wrapIconWithDisplayName(FaSquareRootAlt, "FaSquareRootAlt"),
    wrapIconWithDisplayName(FaStamp, "FaStamp"),
    wrapIconWithDisplayName(FaStar, "FaStar"),
    wrapIconWithDisplayName(FaStarAndCrescent, "FaStarAndCrescent"),
    wrapIconWithDisplayName(FaStarHalf, "FaStarHalf"),
    wrapIconWithDisplayName(FaStarOfDavid, "FaStarOfDavid"),
    wrapIconWithDisplayName(FaStarOfLife, "FaStarOfLife"),
    wrapIconWithDisplayName(FaStepBackward, "FaStepBackward"),
    wrapIconWithDisplayName(FaStepForward, "FaStepForward"),
    wrapIconWithDisplayName(FaStethoscope, "FaStethoscope"),
    wrapIconWithDisplayName(FaStickyNote, "FaStickyNote"),
    wrapIconWithDisplayName(FaStop, "FaStop"),
    wrapIconWithDisplayName(FaStopCircle, "FaStopCircle"),
    wrapIconWithDisplayName(FaStopwatch, "FaStopwatch"),
    wrapIconWithDisplayName(FaStopwatch20, "FaStopwatch20"),
    wrapIconWithDisplayName(FaStore, "FaStore"),
    wrapIconWithDisplayName(FaStoreAlt, "FaStoreAlt"),
    wrapIconWithDisplayName(FaStream, "FaStream"),
    wrapIconWithDisplayName(FaStreetView, "FaStreetView"),
    wrapIconWithDisplayName(FaStrikethrough, "FaStrikethrough"),
    wrapIconWithDisplayName(FaStroopwafel, "FaStroopwafel"),
    wrapIconWithDisplayName(FaSubscript, "FaSubscript"),
    wrapIconWithDisplayName(FaSubway, "FaSubway"),
    wrapIconWithDisplayName(FaSuitcase, "FaSuitcase"),
    wrapIconWithDisplayName(FaSuitcaseRolling, "FaSuitcaseRolling"),
    wrapIconWithDisplayName(FaSun, "FaSun"),
    wrapIconWithDisplayName(FaSuperscript, "FaSuperscript"),
    wrapIconWithDisplayName(FaSurprise, "FaSurprise"),
    wrapIconWithDisplayName(FaSwatchbook, "FaSwatchbook"),
    wrapIconWithDisplayName(FaSwimmer, "FaSwimmer"),
    wrapIconWithDisplayName(FaSwimmingPool, "FaSwimmingPool"),
    wrapIconWithDisplayName(FaSynagogue, "FaSynagogue"),
    wrapIconWithDisplayName(FaSync, "FaSync"),
    wrapIconWithDisplayName(FaSyncAlt, "FaSyncAlt"),
    wrapIconWithDisplayName(FaSyringe, "FaSyringe"),
    wrapIconWithDisplayName(FaTable, "FaTable"),
    wrapIconWithDisplayName(FaTableTennis, "FaTableTennis"),
    wrapIconWithDisplayName(FaTablet, "FaTablet"),
    wrapIconWithDisplayName(FaTabletAlt, "FaTabletAlt"),
    wrapIconWithDisplayName(FaTablets, "FaTablets"),
    wrapIconWithDisplayName(FaTachometerAlt, "FaTachometerAlt"),
    wrapIconWithDisplayName(FaTag, "FaTag"),
    wrapIconWithDisplayName(FaTags, "FaTags"),
    wrapIconWithDisplayName(FaTape, "FaTape"),
    wrapIconWithDisplayName(FaTasks, "FaTasks"),
    wrapIconWithDisplayName(FaTaxi, "FaTaxi"),
    wrapIconWithDisplayName(FaTeeth, "FaTeeth"),
    wrapIconWithDisplayName(FaTeethOpen, "FaTeethOpen"),
    wrapIconWithDisplayName(FaTemperatureHigh, "FaTemperatureHigh"),
    wrapIconWithDisplayName(FaTemperatureLow, "FaTemperatureLow"),
    wrapIconWithDisplayName(FaTenge, "FaTenge"),
    wrapIconWithDisplayName(FaTerminal, "FaTerminal"),
    wrapIconWithDisplayName(FaTextHeight, "FaTextHeight"),
    wrapIconWithDisplayName(FaTextWidth, "FaTextWidth"),
    wrapIconWithDisplayName(FaTh, "FaTh"),
    wrapIconWithDisplayName(FaThLarge, "FaThLarge"),
    wrapIconWithDisplayName(FaThList, "FaThList"),
    wrapIconWithDisplayName(FaTheaterMasks, "FaTheaterMasks"),
    wrapIconWithDisplayName(FaThermometer, "FaThermometer"),
    wrapIconWithDisplayName(FaThumbsDown, "FaThumbsDown"),
    wrapIconWithDisplayName(FaThumbsUp, "FaThumbsUp"),
    wrapIconWithDisplayName(FaThumbtack, "FaThumbtack"),
    wrapIconWithDisplayName(FaTicketAlt, "FaTicketAlt"),
    wrapIconWithDisplayName(FaTimes, "FaTimes"),
    wrapIconWithDisplayName(FaTimesCircle, "FaTimesCircle"),
    wrapIconWithDisplayName(FaTint, "FaTint"),
    wrapIconWithDisplayName(FaTintSlash, "FaTintSlash"),
    wrapIconWithDisplayName(FaTired, "FaTired"),
    wrapIconWithDisplayName(FaToggleOff, "FaToggleOff"),
    wrapIconWithDisplayName(FaToggleOn, "FaToggleOn"),
    wrapIconWithDisplayName(FaToilet, "FaToilet"),
    wrapIconWithDisplayName(FaToiletPaper, "FaToiletPaper"),
    wrapIconWithDisplayName(FaToolbox, "FaToolbox"),
    wrapIconWithDisplayName(FaTools, "FaTools"),
    wrapIconWithDisplayName(FaTooth, "FaTooth"),
    wrapIconWithDisplayName(FaTorah, "FaTorah"),
    wrapIconWithDisplayName(FaToriiGate, "FaToriiGate"),
    wrapIconWithDisplayName(FaTractor, "FaTractor"),
    wrapIconWithDisplayName(FaTrademark, "FaTrademark"),
    wrapIconWithDisplayName(FaTrafficLight, "FaTrafficLight"),
    wrapIconWithDisplayName(FaTrain, "FaTrain"),
    wrapIconWithDisplayName(FaTram, "FaTram"),
    wrapIconWithDisplayName(FaTrash, "FaTrash"),
    wrapIconWithDisplayName(FaTrashAlt, "FaTrashAlt"),
    wrapIconWithDisplayName(FaTree, "FaTree"),
    wrapIconWithDisplayName(FaTrophy, "FaTrophy"),
    wrapIconWithDisplayName(FaTruck, "FaTruck"),
    wrapIconWithDisplayName(FaTruckLoading, "FaTruckLoading"),
    wrapIconWithDisplayName(FaTruckMonster, "FaTruckMonster"),
    wrapIconWithDisplayName(FaTruckMoving, "FaTruckMoving"),
    wrapIconWithDisplayName(FaTruckPickup, "FaTruckPickup"),
    wrapIconWithDisplayName(FaTshirt, "FaTshirt"),
    wrapIconWithDisplayName(FaTty, "FaTty"),
    wrapIconWithDisplayName(FaTv, "FaTv"),
    wrapIconWithDisplayName(FaUmbrella, "FaUmbrella"),
    wrapIconWithDisplayName(FaUmbrellaBeach, "FaUmbrellaBeach"),
    wrapIconWithDisplayName(FaUnderline, "FaUnderline"),
    wrapIconWithDisplayName(FaUndo, "FaUndo"),
    wrapIconWithDisplayName(FaUndoAlt, "FaUndoAlt"),
    wrapIconWithDisplayName(FaUniversalAccess, "FaUniversalAccess"),
    wrapIconWithDisplayName(FaUniversity, "FaUniversity"),
    wrapIconWithDisplayName(FaUnlink, "FaUnlink"),
    wrapIconWithDisplayName(FaUnlock, "FaUnlock"),
    wrapIconWithDisplayName(FaUnlockAlt, "FaUnlockAlt"),
    wrapIconWithDisplayName(FaUpload, "FaUpload"),
    wrapIconWithDisplayName(FaUser, "FaUser"),
    wrapIconWithDisplayName(FaUserAlt, "FaUserAlt"),
    wrapIconWithDisplayName(FaUserAltSlash, "FaUserAltSlash"),
    wrapIconWithDisplayName(FaUserAstronaut, "FaUserAstronaut"),
    wrapIconWithDisplayName(FaUserCheck, "FaUserCheck"),
    wrapIconWithDisplayName(FaUserCircle, "FaUserCircle"),
    wrapIconWithDisplayName(FaUserClock, "FaUserClock"),
    wrapIconWithDisplayName(FaUserCog, "FaUserCog"),
    wrapIconWithDisplayName(FaUserEdit, "FaUserEdit"),
    wrapIconWithDisplayName(FaUserFriends, "FaUserFriends"),
    wrapIconWithDisplayName(FaUserGraduate, "FaUserGraduate"),
    wrapIconWithDisplayName(FaUserInjured, "FaUserInjured"),
    wrapIconWithDisplayName(FaUserLock, "FaUserLock"),
    wrapIconWithDisplayName(FaUserMd, "FaUserMd"),
    wrapIconWithDisplayName(FaUserMinus, "FaUserMinus"),
    wrapIconWithDisplayName(FaUserNinja, "FaUserNinja"),
    wrapIconWithDisplayName(FaUserNurse, "FaUserNurse"),
    wrapIconWithDisplayName(FaUserPlus, "FaUserPlus"),
    wrapIconWithDisplayName(FaUserSecret, "FaUserSecret"),
    wrapIconWithDisplayName(FaUserShield, "FaUserShield"),
    wrapIconWithDisplayName(FaUserSlash, "FaUserSlash"),
    wrapIconWithDisplayName(FaUserTag, "FaUserTag"),
    wrapIconWithDisplayName(FaUserTie, "FaUserTie"),
    wrapIconWithDisplayName(FaUserTimes, "FaUserTimes"),
    wrapIconWithDisplayName(FaUsers, "FaUsers"),
    wrapIconWithDisplayName(FaUtensilSpoon, "FaUtensilSpoon"),
    wrapIconWithDisplayName(FaUtensils, "FaUtensils"),
    wrapIconWithDisplayName(FaVectorSquare, "FaVectorSquare"),
    wrapIconWithDisplayName(FaVenus, "FaVenus"),
    wrapIconWithDisplayName(FaVenusDouble, "FaVenusDouble"),
    wrapIconWithDisplayName(FaVenusMars, "FaVenusMars"),
    wrapIconWithDisplayName(FaVest, "FaVest"),
    wrapIconWithDisplayName(FaVestPatches, "FaVestPatches"),
    wrapIconWithDisplayName(FaVial, "FaVial"),
    wrapIconWithDisplayName(FaVials, "FaVials"),
    wrapIconWithDisplayName(FaVideo, "FaVideo"),
    wrapIconWithDisplayName(FaVideoSlash, "FaVideoSlash"),
    wrapIconWithDisplayName(FaVihara, "FaVihara"),
    wrapIconWithDisplayName(FaVirus, "FaVirus"),
    wrapIconWithDisplayName(FaVirusSlash, "FaVirusSlash"),
    wrapIconWithDisplayName(FaVoicemail, "FaVoicemail"),
    wrapIconWithDisplayName(FaVolleyballBall, "FaVolleyballBall"),
    wrapIconWithDisplayName(FaVolumeDown, "FaVolumeDown"),
    wrapIconWithDisplayName(FaVolumeMute, "FaVolumeMute"),
    wrapIconWithDisplayName(FaVolumeOff, "FaVolumeOff"),
    wrapIconWithDisplayName(FaVolumeUp, "FaVolumeUp"),
    wrapIconWithDisplayName(FaVoteYea, "FaVoteYea"),
    wrapIconWithDisplayName(FaVrCardboard, "FaVrCardboard"),
    wrapIconWithDisplayName(FaWalking, "FaWalking"),
    wrapIconWithDisplayName(FaWallet, "FaWallet"),
    wrapIconWithDisplayName(FaWarehouse, "FaWarehouse"),
    wrapIconWithDisplayName(FaWater, "FaWater"),
    wrapIconWithDisplayName(FaWeight, "FaWeight"),
    wrapIconWithDisplayName(FaWeightHanging, "FaWeightHanging"),
    wrapIconWithDisplayName(FaWheelchair, "FaWheelchair"),
    wrapIconWithDisplayName(FaWifi, "FaWifi"),
    wrapIconWithDisplayName(FaWind, "FaWind"),
    wrapIconWithDisplayName(FaWindowClose, "FaWindowClose"),
    wrapIconWithDisplayName(FaWindowMaximize, "FaWindowMaximize"),
    wrapIconWithDisplayName(FaWindowMinimize, "FaWindowMinimize"),
    wrapIconWithDisplayName(FaWindowRestore, "FaWindowRestore"),
    wrapIconWithDisplayName(FaWineBottle, "FaWineBottle"),
    wrapIconWithDisplayName(FaWineGlass, "FaWineGlass"),
    wrapIconWithDisplayName(FaWineGlassAlt, "FaWineGlassAlt"),
    wrapIconWithDisplayName(FaWonSign, "FaWonSign"),
    wrapIconWithDisplayName(FaWrench, "FaWrench"),
    wrapIconWithDisplayName(FaXRay, "FaXRay"),
    wrapIconWithDisplayName(FaYenSign, "FaYenSign"),
    wrapIconWithDisplayName(FaYinYang, "FaYinYang"),
  ],
};

export default faCategories;
